// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./components/Images/search_lens.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml;utf8,<svg fill=%27%2367768a%27 width=%2716%27 height=%2716%27 viewBox=%270 0 24 24%27><path d=%27M7 10l5 5 5-5%27/></svg>", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Poppins:wght@100;200;300;400;500;600;700;800;900&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --admin-button-color: #0d6efd;
  --warning-color: #ff2323;
  --alert-color: #f8ff87;
  --green-color: #00c07b;
}

.warningColor {
  color: var(--warning-color) !important;
}

.alertColor {
  color: var(--alert-color) !important;
}

.alertColorBg {
  background-color: var(--alert-color) !important;
}

.warningColorBg {
  background-color: var(--warning-color) !important;
}

.greenColorBg {
  background-color: var(--green-color) !important;
}

body {
  font-family: "Poppins" !important;
  background-color: #f0f0f0 !important;
}

/* Scrollbar Styling */
::-webkit-scrollbar {
  width: 6px;
  height: 10px;
}

::-webkit-scrollbar-track {
  background-color: #f0f0f0;
  border-radius: 10px;
}

::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background: #424242;
}

.card {
  box-shadow: none !important;
  border: none !important;
}

.iq-card {
  box-shadow: none !important;
}

button,
p,
input,
label,
span {
  font-family: "Poppins";
}

h1,
h2,
h3,
h4,
h5,
h6 {
  font-family: "Poppins" !important;
}

a {
  text-decoration: none !important;
}

/* Style for the dropdown container */
.editdropdown {
  position: relative;
  display: inline-block;
  /* z-index: 9; */
}

/* Style for the dropdown button */
.editdropdown-button {
  /* background-color:  rgb(240, 240, 240) ; */
  color: #000000;
  padding: 10px 20px;
  border: none;
  cursor: pointer;
}

/* Style for the dropdown menu */
.editdropdown-menu {
  display: none;
  left: -163px;
  top: 0;
  position: absolute;
  background-color: #f9f9f9;
  min-width: 190px;
  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
  z-index: 1;
}

/* Show the dropdown menu when the button is clicked */
.editdropdown:hover .editdropdown-menu {
  display: block;
}

/* Style for dropdown menu items */
.editdropdown-menu a {
  padding: 12px 16px;
  text-decoration: none;
  display: block;
}

.mandatory {
  color: red;
}

.mandatorySimple::after {
  content: "*";
  color: red;
}

.jodit_sticky>.jodit-toolbar__box {
  position: inherit !important;
}

/* Highlight dropdown menu items on hover */
/* Style for the dropdown container */
.editdropdownpage {
  position: relative;
  display: inline-block;
}

/* Style for the dropdown button */
.editdropdownpage-button {
  /* background-color:  rgb(240, 240, 240) ; */
  color: #000000;
  padding: 10px 20px;
  border: none;
  cursor: pointer;
}

/* Style for the dropdown menu */
.editdropdownpage-menu {
  display: none;
  left: -93px;
  position: absolute;
  background-color: #f9f9f9;
  min-width: 100%;
  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
  z-index: 1;
}

/* Show the dropdown menu when the button is clicked */
.editdropdownpage:hover .editdropdownpage-menu {
  display: block;
}

/* Style for dropdown menu items */
.editdropdownpage-menu a {
  color: black;
  padding: 12px 16px;
  text-decoration: none;
  display: block;
}

.mandatory {
  color: red;
}

.notificationofwednesday {
  position: fixed;
  width: 100%;
  z-index: 9999;
  background: black;
  color: white;
}

/* Highlight dropdown menu items on hover */
.editdropdownpage-menu a:hover {
  background-color: #f1f1f1;
}

.green-color {
  color: #d3ffd3;
}

.green-color-bg {
  background-color: #d3ffd3;
}

.yellow-color {
  color: #fff8a6;
}

.dark-green {
  color: green;
}

.PUBLISHED_active {
  background: #d3ffd3;
  color: green;
  font-weight: 600;
  font-size: 13px;
  border-radius: 20px;
  width: 120px;
}

.UNPUBLISHED_active {
  background: #ffd9d9;
  color: red;
  font-weight: 600;
  font-size: 13px;
  border-radius: 20px;
  width: 120px;
}

.ACTIVE_active {
  background: #d3ffd3;
  color: green;
  font-weight: 600;
  font-size: 13px;
  border-radius: 20px;
  width: 120px;
}

.In-ACTIVE_active {
  background: #ffd9d9;
  color: red;
  font-weight: 600;
  font-size: 13px;
  border-radius: 20px;
  width: 120px;
}

.DISABLED_active {
  background: #ffea008a;
  color: #000000;
  font-weight: 600;
  font-size: 13px;
  border-radius: 20px;
  width: 120px;
}

.tabHeading {
  font-family: "museo_sans500" !important;
  font-style: normal;
  font-size: 16px !important;
  color: #424242 !important;
  background-color: transparent;
  position: relative;
  display: block;
}

.tabHeading.active {
  font-family: "museo_sans700" !important;
}

.tabHeading.active::after {
  content: "";
  position: absolute;
  width: 100%;
  bottom: -9px;
  left: 0;
  border-radius: 10px;
  height: 4px;
  background-color: rgb(77, 77, 247);
}

.dashboard a {
  text-decoration: none;
  font-size: 16px;
}

.dashboard p {
  color: #000000;
  font-family: 'Inter';
  font-style: normal;
  font-weight: 400;
  font-size: 15px;
  line-height: 18px;
  text-transform: capitalize;
  color: #161616;
  font-style: normal;
  font-weight: 400;
  line-height: 25px;
  color: #646464;
}

.liveAlert.alert.alert-success.alert-dismissible.fade.show {
  position: fixed;
  top: 10px;
  right: 10px;
  z-index: 9999;
}

.liveAlert.alert.alert-danger.alert-dismissible.fade.show {
  position: fixed;
  top: 10px;
  right: 10px;
  z-index: 9999;
}

.banner-slider .modal {
  top: 50px;
}

.delete_confirm {
  margin-top: 10rem;
}

.success-message i {
  font-size: 50px;
  background-color: transparent;
  border-radius: 50px;
  border: 2px solid greenyellow;
  color: greenyellow;
}

.css-1u9des2-indicatorSeparator {
  width: 0px !important;
}

select {
  height: 50px;
}

.css-1xc3v61-indicatorContainer {
  display: flex;
  transition: color 150ms;
  color: hsl(0deg 3.96% 4.8% / 70%) !important;
  padding: 0px !important;
  box-sizing: border-box;
}

.css-15lsz6c-indicatorContainer {
  display: flex;
  transition: color 150ms;
  color: hsl(0deg 3.96% 4.8% / 70%) !important;
  /* padding: 0px !important; */
  box-sizing: border-box;
}

.css-t3ipsp-control {
  display: flex;
  transition: color 150ms;
  color: hsl(0deg 3.96% 4.8% / 70%) !important;
  padding: 0px !important;
  box-sizing: border-box;
}

.css-1xc3v61-indicatorContainer svg {
  width: 30px !important;
  height: 15px !important;
  top: 14px !important;
}

.css-15lsz6c-indicatorContainer svg {
  width: 18px !important;
  height: 18px !important;
}

.css-15lsz6c-indicatorContainer svg.css-tj5bde-Svg {
  position: absolute;
  right: 10px;
  top: 11px;
}

.css-b62m3t-container {
  /* height: 50px; */
  /* border: 1px solid #e5e5ea !important; */
  border-radius: 5px;
  align-items: center;
  padding: 5px 0 5px 0;
}

.css-13cymwt-control {
  min-height: 45px !important;
}

.thumbnails-images {
  width: auto;
  height: 100px;
}

.thumbnails-upload-images {
  width: 100%;
  height: 65px;
}

#publish_time {
  display: block;
  width: 100%;
  padding: 0.375rem 2.25rem 0.375rem 0.75rem;
  -moz-padding-start: calc(0.75rem - 3px);
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #212529;
  background-color: transparent !important;
  background-repeat: no-repeat;
  background-position: right 0.75rem center;
  background-size: 16px 12px;
  border: transparent !important;
  border-radius: 0.25rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  border: 1px solid #e5e5ea !important;
  height: 50px;
}

/* overlay.css */
.overlay-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 9998;
  display: flex;
  justify-content: center;
  align-items: center;
}

.overlay-icon {
  font-size: 25px;
  color: white;
}

.css-1xc3v61-indicatorContainer svg.css-tj5bde-Svg {
  position: absolute;
  right: 0px;
  top: 11px;
}

.css-1fdsijx-ValueContainer {
  padding: auto !important;
}

.css-15lsz6c-indicatorContainer svg.css-tj5bde-Svg path[d="M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"] {
  display: none;
}

.css-1xc3v61-indicatorContainer svg.css-tj5bde-Svg path[d="M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"] {
  display: none;
}


th {
  text-align-last: start !important;
  padding: 0;
}

td {
  text-align-last: start !important;
  padding: 0;
}

/* New Header siderbar 28/8/2023 */
/* New Header siderbar 28/8/2023 */
/* Mobile view  */
/* Custom, iPhone Retina */
@media only screen and (min-width: 320px) {
  .footerlink {
    font-size: 15px;
    padding: 0;
    margin: 0;
  }
}

/* Extra Small Devices, Phones */
@media only screen and (min-width: 480px) {
  .footerlink {
    font-size: 14px;
    padding: 0;
    margin: 0;
  }
}

/* Small Devices, Tablets */
@media only screen and (min-width: 768px) {
  .footerlink {
    font-size: 14px;
    padding: 0;
    margin: 0;
  }
}

/* Medium Devices, Desktops */
@media only screen and (min-width: 992px) {
  .footerlink {
    font-size: 14px;
    padding: 0;
    margin: 0;
  }
}

/* Large Devices, Wide Screens */
@media only screen and (min-width: 1200px) {}

/* old codes */

.errorred {
  color: #ff2c2c !important;
  font-size: 14px;
  font-weight: 600;
}

.errorredspan {
  position: absolute;
  bottom: -18px;
}

.imageForm {
  display: block;
  position: absolute;
  right: 16px;
  z-index: 1;
  bottom: 11px;
  width: 80px;
  height: 37px;
  object-fit: cover;
}

#nestable>table {
  overflow-x: auto;
}

.approveTable>table {
  overflow-x: auto;
}

#videoPlayer {
  width: 100%;
  height: 100%;
}

.editVideoPlayer {
  width: 125px !important;
  height: 75px;
}

.status {
  width: 80%;
  font-weight: bold;
  margin: 0 auto;
  border-radius: 4px;
}

.closeBtn {
  position: absolute !important;
  right: 0;
  top: 0px;
  width: 40px;
  background: transparent;
  z-index: 100 !important;
  height: 60px;
}

#PendingvideoPlayer {
  width: 100%;
  height: 80px;
}

.exportIcon {
  width: 22px;
  height: 18px;
}

input[type="checkbox"]:checked+label::before {
  background-color: #00f;
  border-color: #00f;
}

.idClass {
  width: 80px !important;
}

.page-link {
  transition: none !important;
}

.page-link:focus {
  box-shadow: none !important;
}

.view-search {
  background: rgba(250, 250, 250, 1);
  border: 1px solid transparent;
  height: 45px;
  font-size: 14px;
  width: 100%;
  border-radius: 4px;
  padding-left: 10px;
  color: #646464 !important;
}

.filterContainer {
  max-width: 270px;
  width: 100%;
  position: relative;
}

.hiddenExport {
  display: none !important;
}

.video-overall-progress-li li {
  list-style-type: none !important;
}

.filter:focus {
  box-shadow: none !important;
}

select#rating {
  border: 1px solid #e5e5ea !important;
  border-radius: 5px !important;
}


select#trailer_type {
  border: 1px solid #e5e5ea !important;
  border-radius: 5px !important;
}

select#access {
  border: 1px solid #e5e5ea !important;
  border-radius: 5px !important;
}

select#url_type {
  border: 1px solid #e5e5ea !important;
  border-radius: 5px !important;
}

select#parent_id {
  border: 1px solid #e5e5ea !important;
  border-radius: 5px !important;
}

select#artist_type {
  border: 1px solid #e5e5ea !important;
  border-radius: 5px !important;
}

select#role_id {
  border: 1px solid #e5e5ea !important;
  border-radius: 5px !important;
}

li {
  list-style-type: none;
}

.form-control.filter {
  max-width: 270px;
  background-size: 18px;
  background-repeat: no-repeat;
  background-position: 11px 13px;
  padding: 8px 37px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  transition: none !important;
}

.totalText {
  /* font-family: "museo_sans700" !important; */
  font-family: "Poppins" !important;
  font-style: normal;
  color: #424242 !important;
  font-size: 20px;
}

/* Shared Icon Positioning for Inputs */
.lockIcon,
.eyeOpen,
.eyeClosed {
  font-size: 18px;
  color: #000;
}

.lockIcon {
  top: 15px;
  left: 10px;
}

.passWordIcon {
  top: 15px;
  right: 17px;
}

.react-bootstrap-table th.sortable {
  position: relative;
}

.react-bs-table-no-data {
  text-align: center;
}

.commonActionPadding {
  padding: 12px 16px;
  cursor: pointer;
}

.modal.packageModel {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9997;
  display: none;
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  outline: 0;
  background-color: rgb(0 0 0 / 41%);
}

.modal.season.packageModel {
  z-index: 9996 !important;
}

.packageModel .btn-close:focus {
  box-shadow: none;
}

.noRecord {
  display: flex;
  justify-content: center;
  font-size: 17px;
  font-weight: bold;
  padding: 10px;
}

.dropzone {
  background-position: left;
  background-size: 75% !important;
  background-repeat: no-repeat;
  justify-content: flex-end !important;
}

.editFormImage {
  max-width: 170px !important;
  height: 100px;
  object-fit: contain;
  display: block;
  margin: 8px 0px;
}

.videoPreview {
  width: 80%;
  margin-right: auto;
  height: 100%;
}

.Toastify__toast {
  border-radius: 16px !important;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12) !important;
  padding: 12px 16px !important;
  min-height: 56px !important;
}

.Toastify__toast-body {
  font-family: "Poppins", sans-serif !important;
  font-weight: 600 !important;
  font-size: 14px !important;
  margin: 0 !important;
  padding: 0 12px !important;
}

.Toastify__toast-icon {
  width: 22px !important;
  margin-inline-end: 12px !important;
}

.Toastify__progress-bar {
  height: 3px !important;
}

.admin-sub-title {
  font-family: "Poppins";
  font-size: 14px;
  line-height: 15px;
  font-weight: 600;
  word-wrap: break-word;
}

.admin-sub-title {
  font-family: "Poppins";
  font-size: 14px;
  line-height: 15px;
  font-weight: 600;
  word-wrap: break-word;
}

.bootstrapTable table>thead>tr {
  border: none;
}

.bootstrapTable table>thead>tr>th {
  border: none;
  font-size: 16px;
  font-family: "Poppins" !important;
  padding: 10px;
  width: 130px;
  font-weight: 500;
  position: relative;
}

.bootstrapTable table>tbody>tr>td {
  white-space: normal;
  word-break: break-all;
  border: none;
  font-size: 15px;
  font-family: "Poppins" !important;
  padding: 10px;
  width: 130px;
  vertical-align: middle;
}

.bootstrapTable.multi-delete-width table>thead>tr>th:nth-child(1) {
  width: 4%;
}

.bootstrapTable .video-width-table {
  width: 200px;
}

.bootstrapTable .page-item.disabled>.page-link {
  opacity: 0.5;
}

.videoWidth>th:nth-child(2) {
  width: 30%;
  position: relative;
}

.videoWidthpartner>th:nth-child(2) {
  width: 10%;
  position: relative;
}

.videoWidth>th:nth-child(2) span {
  position: absolute;
  right: 0;
}

.videoWidth>th {
  width: 100px;
}

.sortable::after {
  content: "\\2193";
  color: #ccc;
  padding: 0px 9px;
  position: absolute;
  right: 12px;
  top: 3px;
  font-size: 18px;
}

.sortable::before {
  content: "\\2191";
  color: #ccc;
  position: absolute;
  right: 12px;
  top: 3px;
  font-size: 18px;
}

th[aria-label="Audios sort asc"].sortable::before {
  color: #0d6efd;
}

th[aria-label="Audios sort desc"].sortable::after {
  color: #0d6efd;
}

th[aria-label="Access sort asc"].sortable::before {
  color: #0d6efd;
}

th[aria-label="Access sort desc"].sortable::after {
  color: #0d6efd;
}

th[aria-label="Videos sort asc"].sortable::before {
  color: #0d6efd;
}

th[aria-label="Videos sort desc"].sortable::after {
  color: #0d6efd;
}

th[aria-label="Upload by sort asc"].sortable::before {
  color: #0d6efd;
}

th[aria-label="Upload sort desc"].sortable::after {
  color: #fff;
}

.profile {
  width: 50px;
  height: 50px;
  object-fit: cover;
  border-radius: 3px;
}

.table-subheading {
  font-size: 12px;
}

.rightVideoTitle {
  width: 200px;
}

.sliderBtnText {
  font-size: 13px !important;
  font-family: "Poppins" !important;
}

.admin-button-text {
  font-family: "Poppins" !important;
  font-weight: 600 !important;
  font-size: 15px !important;
  line-height: 20px !important;
}

.button-color {
  color: #fff !important;
}


.admin-input-title {
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
}

.svgIcon {
  fill: none;
  stroke: currentColor;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-width: 0.75px;
}

.bootstrapTable .react-bs-table-sizePerPage-dropdown .dropdown-menu {
  bottom: 32px;
}

.bootstrapTable .react-bs-table-sizePerPage-dropdown .dropdown-item>a {
  display: block;
}

#pageDropDown {
  transition: none !important;
}

#pageDropDown:focus {
  box-shadow: none !important;
}

.react-bootstrap-table-page-btns-ul {
  justify-content: end;
}

.clearBtn {
  top: 10px;
  position: absolute;
  right: 0;
  background: transparent;
}

.custom-close-btn {
  width: 20px;
  height: 20px;
  fill: currentColor;
}

.adminHeadContainer {
  min-height: calc(100vh - 120px);
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  transition: all 0.4s;
}

.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}

input:checked+.slider {
  background-color: #2196f3;
}

input:focus+.slider {
  box-shadow: 0 0 1px #2196f3;
}

.slider:before {
  position: absolute;
  content: "";
  height: 15px;
  width: 15px;
  left: 4px;
  bottom: 3px;
  background-color: white;
  transition: all 0.4s;
}

input:checked+.slider:before {
  left: 26px;
}

.switch {
  position: relative;
  display: inline-block;
  width: 45px;
  height: 20px;
}

.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.custom-placeholder::placeholder {
  font-family: "Poppins" !important;
}

.imagedropcopy {
  align-items: center;
  justify-content: center;
  border-radius: 5px;
  border-style: dashed;
  border-color: #cbd5e1;
  cursor: pointer;
  min-height: 70px;
  height: auto;
  width: 80%;
}

.imagedropcopyimage {
  align-items: center;
  justify-content: center;
  border-radius: 5px;
  border-style: dashed;
  border-color: #cbd5e1;
  width: 100%;
  cursor: pointer;
}

.admin-title {
  font-size: 30px;
  line-height: 40px;
  font-weight: bold;
}

.customDropWrapper {
  width: 100%;
  height: 250px;
  border: 2px dashed rgba(99, 102, 241, 0.4);
  background: rgba(99, 102, 241, 0.02);
  position: relative;
  border-radius: 16px;
  transition: all 0.3s ease;
  cursor: pointer;
}

.customDropWrapper input {
  opacity: 0;
}

.customDropWrapper:hover {
  border-color: #6366f1;
  background: rgba(99, 102, 241, 0.05);
}

.dropZoneText {
  position: absolute;
  top: 0;
  margin: 0 auto;
  left: 0;
  right: 0;
  height: 100%;
}

.rowCheckboxDrag {
  width: 4% !important;
}

.rowCheckboxfooterDrag {
  width: 9% !important;
}

.category-order-title {
  padding: 10px;
  font-size: 16px;
  white-space: normal;
  word-break: break-all;
  border: none;
}

.border-width {
  border-width: 2px !important;
}

.border-solid-width {
  border-width: 1px;
}

.orderHeading {
  font-size: 16px;
  font-weight: bold;
  line-height: 37px;
  font-family: 'Poppins';
}

.orderContainer>div:not(:nth-child(2), :nth-child(1), :nth-child(4)) {
  width: 15%;
}

.orderContainer>div:nth-child(1) {
  width: 5%;
}

.orderContainer>div:nth-child(2) {
  width: 25%;
}

.orderContainer>div:nth-child(4) {
  width: 15%;
}

.reloadButton {
  width: 35px;
  height: 35px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.custom-tool-tip-parent {
  position: relative;
}

.custom-tool-tip-parent:hover .custom-tool-tip {
  display: block !important;
}

.cursor-pointer {
  cursor: pointer;
}

.modal-description {
  font-size: 14px;
  line-height: 20px;
  font-weight: 500;
}

.imagedrop {
  /* width: 100%; */
  width: 80%;
  height: 70px;
  /* height: 120px; */
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 5px;
  border-style: dashed;
  border-color: #cbd5e1;
  cursor: pointer;
}

.image-close {
  position: absolute;
  top: -16px;
  right: -14px;
  width: 22px !important;
  height: 22px !important;
  opacity: 1 !important;
  border-style: dashed !important;
  border-width: 2px !important;
  border-color: #cbd5e1 !important;
}

.custom-input {
  font-size: 13px;
  padding: 15px 20px;
  border-radius: 7px;
  font-weight: 500;
}

input[readonly]:focus {
  outline: none;
}

.focus-hide:focus {
  outline: 0;
}

.rti--container {
  padding: 11px 15px !important;
}

.rti--tag>span {
  padding: 4px 15px;
  border-radius: 2px;
}

.rti--tag>button {
  padding: 3px 5px !important;
  border-radius: 0px !important;
}


.admin-input-description {
  font-size: 13px;
  min-width: 80px;
}

.copy-board-container {
  cursor: pointer;
  position: absolute;
  top: -1px;
  width: 55px;
  right: -1px;
  border-top-right-radius: 9px;
  border-bottom-right-radius: 9px;
  height: 51px;
}

.copy-board-input {
  padding-right: 55px;
}


.copy-reply {
  top: -45px;
  right: 6px;
}

.tool-tip-text {
  top: -44px;
  padding: 10px;
  left: 136px;
  font-size: 10px;
  border-radius: 6px;
  width: 180px;
  line-height: 15px;
}

.tool-tip-open:hover .tool-tip-text {
  display: block !important;
}

.labelLoader {
  width: 30%;
  height: 20px;
  border-radius: 3px;
}

.headingLoader {
  width: 50%;
  height: 35px;
  border-radius: 3px;
}

.subHeadingLoader {
  width: 40%;
  height: 14px;
  border-radius: 3px;
}

.square {
  background: rgba(130, 130, 130, 0.2);
  background: linear-gradient(to right,
      rgba(130, 130, 130, 0.2) 8%,
      rgba(130, 130, 130, 0.3) 18%,
      rgba(130, 130, 130, 0.2) 33%);
  background-size: 800px 100px;
  animation: wave-squares 2s infinite ease-out;
}

@keyframes wave-squares {
  0% {
    background-position: -468px 0;
  }

  100% {
    background-position: 468px 0;
  }
}

.cancal-position {
  top: 2px;
  right: 5px;
}

.cancal-position>svg {
  width: 15px;
  height: 15px;
}

.progressHeight {
  height: 30px;
}

.percentagePop {
  top: 5px;
  left: 0;
  right: 0;
  margin: 0 auto;
  width: 20px;
  height: 10px;
  border: 0;
}

.progressSmall {
  height: 15px;
}

.progressSubText {
  font-size: 13px;
  font-weight: 500;
  margin-bottom: 3px;
}

.progressButton {
  font-size: 10px;
  padding: 3px 13px;
}

.percentageText {
  top: 0px;
  left: 0;
  right: 0;
  margin: 0 auto;
  font-size: 11px;
  width: 20px;
  height: 14px;
  border: 0;
}

.progressFileNameElip {
  width: 110px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.modal-large {
  max-width: 800px !important;
}

.priceTable {
  height: 300px;
  overflow-y: overlay;
}

.priceTable thead {
  position: sticky;
  top: 0;
}

.AdminUploadIndicator {
  position: fixed;
  bottom: 50px;
  right: 10px;
  width: 400px;
  z-index: 998;
  border-top-left-radius: 25px;
  border-top-right-radius: 25px;
  height: auto;
  max-height: 450px;
  transition: height 1s ease;
}

.overflow-scroll-indicator {
  overflow: hidden overlay;
}

.overflow-hidden-indicator {
  overflow-x: hidden !important;
}

.upload-indicator-header {
  top: 0;
  z-index: 998;
}

.AdminUploadIndicator.collapse-zone {
  height: 50px;
}

.indicator-width {
  width: 200px;
}

.successFull {
  background-color: #3cb043;
}

.indicator-file-name {
  width: 200px;
  height: 20px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.indicatorButon {
  width: 58px;
}

.list-height {
  height: 68px;
}

.cancelText {
  font-size: 10px;
}

.sizeText {
  font-size: 10px;
  font-weight: bold;
}

.speedText {
  font-size: 10px;
  font-weight: 600;
}

.border-solid {
  border-style: solid;
}

.rotate-arrow {
  transform: rotate(180deg);
}

.from-indicator {
  padding: 2px 9px;
  font-size: 8px;
  top: -11px;
  left: -2px;
  background-color: rgb(241, 241, 115);
}

.galleryBox {
  height: 400px;
  overflow-y: scroll;
}

.galleryImage {
  height: 150px;
  object-fit: cover;
}

.galleryTitle {
  font-size: 13px;
  font-weight: 500;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 20px;
}

.galleryDuration {
  font-size: 11px;
  font-weight: 400;
}

.galleryButton {
  width: 30px;
  height: 30px;
}

.galleryAfter::after {
  content: '' !important;
  display: none !important;
}

.galleryCheckBox {
  position: absolute;
  top: 38px;
  left: 37px;
  height: 21px;
  width: 21px;
}

.hideArrow::after {
  border: none !important;
}

.custom-datepicker {
  width: 250;
  border: 1px solid #ccc;
  border-radius: 6px;
}

.custom-datepicker .rs-picker-toggle-value {
  color: black !important;
}

.rs-picker-daterange-header {
  display: none !important;
}

.z-index-1 {
  z-index: 1;
}

.table-column-title.avoid-overflow-ellipsis {
  text-overflow: unset;
  overflow: unset;
  white-space: unset;
  max-width: unset;
}

@media screen and (max-width: 423px) {
  .deleteBtn {
    width: 100%;
  }
}

.tooltip-disabled {
  font-size: 11px;
  background-color: #333;
  color: #fff;
  padding: 5px 8px;
  border-radius: 4px;
  white-space: nowrap;
  z-index: 9999 !important;
}

.custom-page-select {
  background-color: #ffffff;
  color: #000;
}

select.select-view-type {
  width: 100px !important;
}

.admin-tooltip {
  border-radius: 6px;
  white-space: nowrap;
  transition: opacity 0.2s ease;
  pointer-events: none;
}

.tooltip-container:hover .admin-tooltip {
  pointer-events: auto;
}

.admin-tooltip::after {
  content: "";
  position: absolute;
  top: 100%;
  left: 50%;
  margin-left: -5px;
  border-width: 5px;
  border-style: solid;
  border-color: #000 transparent transparent transparent;
}

.tooltip-container .custom-hover-tooltip {
  opacity: 0;
  visibility: hidden;
  transform: translateX(-50%) translateY(10px);
  transition: opacity 0.2s ease, transform 0.2s ease;
  pointer-events: none;
  position: absolute;
  z-index: 9999;
}

.tooltip-container:hover .custom-hover-tooltip {
  opacity: 1;
  visibility: visible;
  transform: translateX(-50%) translateY(0);
  pointer-events: auto;
}

.custom-hover-tooltip::after {
  content: "";
  position: absolute;
  top: 100%;
  left: 50%;
  margin-left: -5px;
  border-width: 5px;
  border-style: solid;
  border-color: #000 transparent transparent transparent;
}

.trailer-episode-image {
  height: 50px;
  width: 50px;
  object-fit: cover;
}

.rtmpurleditbg :hover {
  background-color: rgb(245, 247, 252) !important;
}

.logoPay {
  width: 160px;
  height: 50px;
  object-fit: contain;
}

.drag-handle {
  cursor: grab;
  -webkit-user-select: none;
          user-select: none;
}

.modalBackdropdataserviceunavailable {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #000000;
  color: #ffffff;
  opacity: 0.8;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10007;
}

.modalContentdataserviceunavailable {
  background-color: #000000;
  color: #ffffff;
  padding: 2rem;
  opacity: 1;
  border-radius: 10px;
  max-width: 700px;
  text-align: center;
}

.hide-checkbox-row td input[type="checkbox"] {
  display: none !important;
}

.counter_timing {
  border-radius: 0.8em;
  -moz-border-radius: 0.8em;
  display: inline-block;
  line-height: 1.6em;
  margin-left: 20px;
  text-align: center;
  width: 1.6em;
}


.modern-modal {
  border-radius: 20px !important;
  padding: 10px 10px 20px;
  box-shadow: 0 15px 35px rgba(0, 0, 0, 0.20);
  border: none;
}

.modern-backdrop {
  backdrop-filter: blur(4px);
}

.upgrade-btn {
  background: linear-gradient(135deg, #ff8a00, #ff4d00);
  color: #fff !important;
  padding: 12px;
  border-radius: 12px;
  font-weight: 600;
  text-decoration: none;
  display: inline-block;
  transition: 0.2s ease;
}

.upgrade-btn:hover {
  opacity: 0.9;
}

.modal-title {
  font-size: 1.25rem;
}

.sub-page {
  display: grid;
  grid-template-columns: 3fr 1.3fr;
  gap: 24px;
}

.sub-card,
.checkout-card {
  background: #fff;
  border-radius: 10px;
  padding: 20px 24px;
  box-shadow: 0 2px 8px rgba(15, 23, 42, 0.05);
}

.sub-title {
  font-size: 26px;
  font-weight: 800;
  margin-bottom: 8px;
  color: #111827;
  letter-spacing: -0.5px;
}

.sub-tabs {
  display: flex;
  gap: 24px;
  border-bottom: 1px solid #e5e7eb;
}

.tab {
  padding: 10px 0;
  border: none;
  background: none;
  cursor: pointer;
  font-size: 14px;
  color: #6b7280;
  border-bottom: 2px solid transparent;
}

.tab.active {
  color: #111827;
  font-weight: 600;
  border-color: #2563eb;
}

.tab-body {
  padding-top: 20px;
}

.section-title {
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 16px;
}

.subscription-row {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 16px;
}

.row {
  display: flex;
  justify-content: space-between;
  margin-bottom: 8px;
  font-size: 14px;
}

.label {
  font-weight: 600;
  color: #374151;
}

.badge {
  background: #e5edff;
  color: #2563eb;
  padding: 4px 10px;
  border-radius: 999px;
  font-size: 12px;
}

.status-pill {
  margin-left: auto;
  background: #dcfce7;
  color: #15803d;
  padding: 4px 10px;
  border-radius: 999px;
  font-size: 12px;
}

.plans-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 16px;
}

.plan-card {
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 12px 14px;
}

.plan-head {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
}

.plan-price {
  display: flex;
  align-items: baseline;
  gap: 4px;
}

.price {
  font-size: 18px;
  font-weight: 600;
}

.cycle {
  font-size: 12px;
  color: #6b7280;
}

.btn-outline {
  margin-top: 8px;
  width: 100%;
  padding: 8px 0;
  border-radius: 6px;
  border: 1px solid #2563eb;
  background: #fff;
  color: #2563eb;
  cursor: pointer;
}

.checkout-card h3 {
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 16px;
}

.total-row span:last-child {
  font-weight: 700;
}

.btn-primary.full {
  margin-top: 20px;
  width: 100%;
  padding: 10px 0;
  border-radius: 6px;
  border: none;
  background: #2563eb;
  color: #fff;
  cursor: pointer;
}

.addons-section {
  margin-bottom: 24px;
}

.plans-grid.compact {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  row-gap: 10px;
}

.pricing-card.small {
  flex: 0 0 240px;
  max-width: 240px;
  border: 1px solid #e5e7eb;
  border-radius: 14px;
  padding: 16px;
  background: #fff;
  cursor: pointer;
  transition: 0.2s ease;
}

.addons-title {
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 12px;
}

.addon-card {
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 12px 14px;
  margin-bottom: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  transition: all 0.2s ease-in-out;
}

.addon-card.purchased {
  background: #f0fdf4;
  border-color: #bbf7d0;
}

.addon-name {
  margin: 0;
  font-size: 15px;
  font-weight: 600;
}

.addon-price {
  margin: 0;
  font-size: 13px;
  color: #6b7280;
}

.purchased-badge {
  background: #059669;
  color: white;
  padding: 4px 10px;
  border-radius: 999px;
  font-size: 12px;
}

.btn-outline-danger {
  margin-top: 8px;
  width: 100px;
  padding: 8px 0;
  border-radius: 6px;
  border: 1px solid #dc2626;
  color: #dc2626;
  background: #fff;
  cursor: pointer;
}

.save-tag {
  font-size: 11px;
  padding: 2px 6px;
  border-radius: 999px;
  background: rgba(16, 185, 129, 0.14);
  color: #047857;
  font-weight: 600;
}

/* Existing pricing card styles (keep yours, add tweaks if needed) */
.pricing-card.small {
  width: 260px;
  border: 1px solid #e5e7eb;
  border-radius: 14px;
  padding: 18px;
  background: #fff;
  cursor: pointer;
  transition: 0.2s ease;
}

.pricing-card.small:hover {
  transform: translateY(-3px);
  border-color: #2563eb;
  box-shadow: 0 10px 25px rgba(15, 23, 42, 0.07);
}

.pricing-card.small.active {
  border: 2px solid #2563eb;
  background: #eef4ff;
}

.card-top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 14px;
}

.plan-name {
  font-size: 18px;
  font-weight: 700;
  margin: 0;
}

.plan-icon {
  font-size: 22px;
  color: #9ca3af;
}

.selected-icon {
  font-size: 22px;
  color: #2563eb;
}

.price-block {
  margin-top: 10px;
}

.price-main {
  font-size: 26px;
  font-weight: 800;
}

.cycle {
  font-size: 15px;
  color: #6b7280;
  margin-left: 4px;
}

.price-strike {
  margin-top: 3px;
  text-decoration: line-through;
  color: #9ca3af;
  font-size: 15px;
}

.addon-card:hover {
  transform: translateY(-3px);
  box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.08);
}

.modern-select select {
  padding-left: 36px;
  border-radius: 10px;
  font-size: 15px;
}

/* Wrapper prevents clipping */
.dropdown-wrapper {
  position: relative;
  overflow: visible !important;
}

/* Dropdown container */
.custom-dropdown {
  position: relative;
  width: 220px;
}

.dd-select {
  padding-left: 40px !important;
  padding-right: 40px !important;
  border-radius: 12px !important;
  height: 42px;
  font-size: 15px;
  background: #ffffff;
  border: 1px solid #dcdcdc;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  cursor: pointer;
  appearance: none;
  /* Hide default arrow */
}

/* Funnel icon */
.dd-icon {
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
  color: #6c757d;
  font-size: 16px;
  pointer-events: none;
}

/* Custom arrow */
.custom-dropdown::after {
  content: "▼";
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 10px;
  color: #6c757d;
  pointer-events: none;
}

/* Focus highlight */
.dd-select:focus {
  border-color: #4e74ff !important;
  box-shadow: 0 0 0 3px rgba(78, 116, 255, 0.25) !important;
}

/* Ensure dropdown never gets cut */
select {
  overflow: visible !important;
}

.dropdown-menu {
  z-index: 9999 !important;
}

.subscription-container {
  background: #ffffff;
  border-radius: 14px;
  padding: 28px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.04);
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.sub-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.sub-title {
  font-size: 22px;
  font-weight: 700;
  color: #111827;
}

.status-badge {
  padding: 6px 14px;
  font-size: 13px;
  border-radius: 12px;
  background: #e0fbe8;
  color: #15803d;
  font-weight: 600;
}

.plan-card-modern {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #f8f9ff;
  border: 1px solid #e1e6ff;
  padding: 18px 20px;
  border-radius: 12px;
}

.plan-label {
  font-size: 13px;
  color: #6b7280;
  margin-bottom: 2px;
}

.plan-name {
  font-size: 20px;
  font-weight: 700;
  color: #1e3a8a;
}

.plan-tag {
  padding: 6px 14px;
  font-size: 12px;
  background: #eef2ff;
  color: #4338ca;
  border-radius: 12px;
  font-weight: 600;
}

.info-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  gap: 18px;
}

.info-item {
  background: #fafafa;
  border: 1px solid #f0f0f0;
  padding: 14px 16px;
  border-radius: 12px;
}

.info-item.full {
  grid-column: 1 / -1;
}

.info-label {
  font-size: 12px;
  text-transform: uppercase;
  color: #6b7280;
  letter-spacing: 0.5px;
  margin-bottom: 4px;
  font-weight: 600;
}

.info-value {
  font-size: 15px;
  font-weight: 600;
  color: #111827;
}

.divider {
  border: none;
  border-top: 1px solid #e5e7eb;
  margin: 10px 0;
}

.checkout-card-modern {
  background: #ffffff;
  border-radius: 14px;
  padding: 20px 22px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  border: 1px solid #f0f2f5;
}

.checkout-title {
  font-size: 19px;
  font-weight: 600;
  margin-bottom: 15px;
}

.checkout-row {
  display: flex;
  justify-content: space-between;
  padding: 6px 0;
  font-size: 14px;
}

.value {
  font-weight: 600;
}

.total-row .value.total {
  font-size: 18px;
  color: #111;
  font-weight: 700;
}

.divider-light {
  border-top: 1px dashed #ddd;
  margin: 10px 0;
}

.highlight-row {
  background: #f9f2ff;
  padding: 8px 10px;
  border-radius: 8px;
  font-weight: 600;
  color: #6a00ff;
}

.subtle-row {
  color: #555;
  font-size: 13.5px;
}

.next-billing-text {
  margin-top: 6px;
  font-size: 12.5px;
  color: #666;
}

.cancel-btn {
  background: #e63946;
  color: white;
  padding: 10px 18px;
  border-radius: 8px;
  border: none;
  font-size: 14px;
  cursor: pointer;
  margin-top: 20px;
}

.cancel-btn:hover {
  background: #d62828;
}

.disabled-card {
  cursor: not-allowed !important;
  border-color: #d1d5db !important;
  pointer-events: none;
}

.disabled-card:hover {
  transform: none !important;
  box-shadow: none !important;
}

.purchased-pill {
  background: #10b981;
  color: #fff;
  padding: 4px 10px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 600;
  display: inline-block;
}

.pricing-header-v3 {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 28px;
}

.pricing-title-v3 {
  font-size: 26px;
  font-weight: 700;
  color: #0f172a;
}

.pricing-subtitle-v3 {
  font-size: 14px;
  color: #64748b;
  margin-top: 4px;
}

.pricing-switch-group-v3 {
  display: flex;
  align-items: center;
  gap: 15px;
}

.currency-select {
  appearance: none;
  padding: 10px 42px 10px 16px;
  font-size: 15px;
  font-weight: 600;
  background: #ffffff;
  border: 2px solid #e2e8f0;
  border-radius: 14px;
  cursor: pointer;
  transition: all 0.25s ease;
  box-shadow: 0 3px 10px rgba(15, 23, 42, 0.08);
  color: #0f172a;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-position: right 12px center;
  background-repeat: no-repeat;
}

.currency-select:hover {
  border-color: #cbd5e1;
  background-color: #f8fafc;
}

.currency-select:focus {
  border-color: #6366f1;
  box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.2);
  outline: none;
}

.currency-select option {
  font-size: 15px;
  font-weight: 500;
  padding: 8px;
}

.billing-toggle {
  position: relative;
  display: inline-flex;
  align-items: center;
  background: #f1f5f9;
  border-radius: 999px;
  padding: 6px;
  gap: 6px;
  border: 1px solid #e2e8f0;
  box-shadow: inset 0 1px 3px rgba(0, 0, 0, 0.06);
}

.toggle-btn {
  position: relative;
  z-index: 2;
  border: none;
  background: none;
  padding: 10px 26px;
  font-size: 15px;
  font-weight: 600;
  color: #475569;
  cursor: pointer;
  border-radius: 999px;
  white-space: nowrap;
  transition: color 0.25s ease;
}

.toggle-btn.active {
  color: #fff;
  font-weight: 700;
}

.toggle-highlight {
  position: absolute;
  top: 6px;
  bottom: 6px;
  background: linear-gradient(135deg, #6366f1, #7c3aed);
  border-radius: 999px;
  box-shadow: 0px 6px 22px rgba(99, 102, 241, 0.35);
  z-index: 1;
  transition: all 0.28s ease;
}

.toggle-left {
  transform: translateX(0%);
  width: calc(50% - 6px);
}

.toggle-right {
  transform: translateX(100%);
  width: calc(50% - 6px);
}

.baseservices-section {
  padding: 30px 15px;
  max-width: 1200px;
  margin: auto;
}

.baseservices-title {
  font-size: 28px;
  font-weight: 700;
  margin-bottom: 6px;
}

.baseservices-subtitle {
  color: #777;
  margin-bottom: 32px;
}

.baseservices-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
  gap: 24px;
}

.baseservice-card {
  background: #fff;
  border-radius: 18px;
  padding: 24px;
  box-shadow: 0 6px 24px rgba(0, 0, 0, 0.06);
  display: flex;
  flex-direction: column;
  transition: 0.3s ease;
}

.baseservice-card:hover {
  transform: translateY(-6px);
  box-shadow: 0 12px 36px rgba(0, 0, 0, 0.1);
}

.baseservice-card h3 {
  font-size: 18px;
  font-weight: 700;
  margin: 12px 0 10px;
}

.baseservice-card p {
  color: #666;
  font-size: 14px;
  line-height: 1.6;
  flex-grow: 1;
}

.baseservice-btn-wrap {
  margin-top: 18px;
}

.baseservice-icon {
  width: 44px;
  height: 44px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  color: #fff;
}

.baseservice-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 10px 16px;
  border-radius: 10px;
  font-size: 14px;
  font-weight: 600;
  color: #fff;
  text-decoration: none;
  transition: 0.3s ease;
}

.baseservice-btn .arrow {
  display: inline-block;
  transition: transform 0.3s ease;
}

.baseservice-btn:hover .arrow {
  transform: translateX(6px);
}

.baseservice-btn:hover {
  color: #fff;
}

.flicknexs {
  background: #2563eb;
  color: #fff;
}

.flicknexs:hover {
  background: #2563eb;
  color: #fff;
}

.purple {
  background: #7c3aed;
}

.primary {
  background: #2563eb;
}

.warning {
  background: #f97316;
}

.dark {
  background: #111827;
}

.success {
  background: #16a34a;
}

.info {
  background: #6366f1;
}

.danger {
  background: #db2777;
}

.adminforgot .model-x-button button {
  font-size: 13px;
  right: 5px;
  top: 5px;
}


@media (max-width: 900px) {
  .sub-page {
    grid-template-columns: 1fr;
  }
}

@keyframes shimmer {
  100% {
    transform: translateX(100%);
  }
}

/* ==========================================================================
   PREMIUM FILE UPLOADER COMPONENT STYLES
   ========================================================================== */

.premium-uploader-container {
  width: 100%;
  max-width: 620px;
  margin: 24px auto;
  font-family: "Poppins", "Inter", sans-serif;
}

/* Premium Dropzone Area */
.premium-dropzone {
  border: 2px dashed rgba(99, 102, 241, 0.4);
  background: rgba(99, 102, 241, 0.03);
  padding: 42px 28px;
  text-align: center;
  cursor: pointer;
  border-radius: 20px;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  overflow: hidden;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);
}

.premium-dropzone:hover {
  border-color: #6366f1;
  background: rgba(99, 102, 241, 0.06);
  transform: translateY(-2px);
  box-shadow: 0 10px 30px rgba(99, 102, 241, 0.1);
}

.premium-dropzone.is-dragging {
  border-color: #10b981;
  background: rgba(16, 185, 129, 0.08);
  transform: scale(1.02);
  box-shadow: 0 12px 35px rgba(16, 185, 129, 0.15);
}

/* Icon wrapper with glow & pulse animation */
.premium-dropzone-icon-wrapper {
  width: 68px;
  height: 68px;
  margin: 0 auto 16px;
  background: linear-gradient(135deg, rgba(99, 102, 241, 0.12) 0%, rgba(168, 85, 247, 0.12) 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
}

.premium-dropzone:hover .premium-dropzone-icon-wrapper {
  transform: translateY(-4px) scale(1.08);
  background: linear-gradient(135deg, rgba(99, 102, 241, 0.2) 0%, rgba(168, 85, 247, 0.2) 100%);
}

.premium-dropzone.is-dragging .premium-dropzone-icon-wrapper {
  background: linear-gradient(135deg, rgba(16, 185, 129, 0.18) 0%, rgba(52, 211, 153, 0.18) 100%);
  transform: scale(1.1);
}

.premium-dropzone-icon {
  font-size: 30px;
  color: #6366f1;
  transition: all 0.3s ease;
}

.premium-dropzone:hover .premium-dropzone-icon {
  color: #a855f7;
}

.premium-dropzone.is-dragging .premium-dropzone-icon {
  color: #10b981;
}

/* Text structure */
.premium-dropzone-title {
  margin: 0 0 6px;
  font-size: 1.15rem;
  font-weight: 600;
  color: inherit;
}

.premium-dropzone-subtitle {
  margin: 0 0 20px;
  font-size: 0.9rem;
  color: #6b7280;
}

/* Tag specs styling */
.premium-dropzone-specs {
  display: flex;
  justify-content: center;
  gap: 10px;
  flex-wrap: wrap;
}

.spec-tag {
  background: rgba(255, 255, 255, 0.7);
  border: 1px solid rgba(0, 0, 0, 0.05);
  padding: 5px 12px;
  border-radius: 50px;
  font-size: 0.75rem;
  font-weight: 500;
  color: #4b5563;
  transition: all 0.2s ease;
}

/* Dark mode compatibility */
.theme-bg-color-secondary .spec-tag {
  background: rgba(255, 255, 255, 0.05);
  border-color: rgba(255, 255, 255, 0.08);
  color: #d1d5db;
}

.premium-dropzone:hover .spec-tag {
  background: rgba(99, 102, 241, 0.08);
  border-color: rgba(99, 102, 241, 0.15);
  color: #6366f1;
}

/* File list section styling */
.premium-file-list {
  margin-top: 28px;
  animation: premiumFadeIn 0.4s ease-out;
}

.premium-file-list-header {
  margin-bottom: 12px;
}

.premium-file-list-header h4 {
  font-size: 0.95rem;
  font-weight: 600;
  margin: 0;
  color: inherit;
}

.premium-file-list-items {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

/* High fidelity card for items in upload list */
.premium-file-card {
  background: rgba(255, 255, 255, 0.4);
  border: 1px solid rgba(99, 102, 241, 0.1);
  border-radius: 16px;
  padding: 16px;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.02);
}

.theme-bg-color-secondary .premium-file-card {
  background: rgba(255, 255, 255, 0.02);
  border-color: rgba(255, 255, 255, 0.05);
}

.premium-file-card:hover {
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.06);
  transform: translateY(-1px);
}

/* Card Header - File info */
.premium-file-info {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 12px;
}

.file-icon-wrapper {
  width: 40px;
  height: 40px;
  background: rgba(99, 102, 241, 0.08);
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.file-icon {
  font-size: 18px;
  color: #6366f1;
}

.file-metadata {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.file-name {
  font-size: 0.9rem;
  font-weight: 600;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: inherit;
}

.file-size {
  font-size: 0.75rem;
  color: #6b7280;
  margin-top: 1px;
}

/* Button styling inside queue cards */
.file-actions {
  display: flex;
  gap: 6px;
  align-items: center;
}

.btn-action {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;
  font-size: 13px;
  background: rgba(0, 0, 0, 0.04);
  color: #4b5563;
}

.theme-bg-color-secondary .btn-action {
  background: rgba(255, 255, 255, 0.06);
  color: #d1d5db;
}

.btn-action:hover {
  transform: scale(1.1);
}

.btn-action.pause:hover {
  background: rgba(239, 68, 68, 0.12);
  color: #ef4444;
}

.btn-action.resume:hover {
  background: rgba(16, 185, 129, 0.12);
  color: #10b981;
}

.btn-action.remove:hover {
  background: rgba(239, 68, 68, 0.12);
  color: #ef4444;
}

/* Progress bar inside cards */
.premium-progress-container {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.premium-progress-bar-wrapper {
  width: 100%;
  height: 5px;
  background: rgba(0, 0, 0, 0.05);
  border-radius: 10px;
  overflow: hidden;
}

.theme-bg-color-secondary .premium-progress-bar-wrapper {
  background: rgba(255, 255, 255, 0.08);
}

.premium-progress-bar {
  height: 100%;
  border-radius: 10px;
  transition: width 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  background: linear-gradient(90deg, #6366f1 0%, #a855f7 100%);
}

.premium-progress-bar.done {
  background: #10b981;
}

.premium-progress-bar.error {
  background: #ef4444;
}

.premium-progress-bar.cancelled {
  background: #f59e0b;
}

/* Details row under progress bar */
.premium-progress-details {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 0.78rem;
  font-weight: 500;
}

.progress-status-text {
  display: flex;
  align-items: center;
}

.progress-speed {
  color: #4b5563;
}

.theme-bg-color-secondary .progress-speed {
  color: #9ca3af;
}

.text-success-g {
  color: #10b981 !important;
}

.text-warning-g {
  color: #f59e0b !important;
}

.text-error-g {
  color: #ef4444 !important;
}

.me-1 {
  margin-right: 4px;
}

/* Spinner and micro animations */
.spin {
  animation: premiumSpin 1s linear infinite;
}

.animate-pulse {
  animation: premiumPulse 1.5s ease-in-out infinite;
}

@keyframes premiumSpin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

@keyframes premiumFadeIn {
  from { opacity: 0; transform: translateY(8px); }
  to { opacity: 1; transform: translateY(0); }
}

@keyframes premiumPulse {
  0%, 100% { opacity: 1; }
  50% { opacity: .6; }
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAEA;EACE,6BAA6B;EAC7B,wBAAwB;EACxB,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,iDAAiD;AACnD;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,iCAAiC;EACjC,oCAAoC;AACtC;;AAEA,sBAAsB;AACtB;EACE,UAAU;EACV,YAAY;AACd;;AAEA;EACE,yBAAyB;EAEzB,mBAAmB;AACrB;;AAEA;EAEE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,uBAAuB;AACzB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;;;;;EAKE,sBAAsB;AACxB;;AAEA;;;;;;EAME,iCAAiC;AACnC;;AAEA;EACE,gCAAgC;AAClC;;AAEA,qCAAqC;AACrC;EACE,kBAAkB;EAClB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA,kCAAkC;AAClC;EACE,4CAA4C;EAC5C,cAAc;EACd,kBAAkB;EAClB,YAAY;EACZ,eAAe;AACjB;;AAEA,gCAAgC;AAChC;EACE,aAAa;EACb,YAAY;EACZ,MAAM;EACN,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,+CAA+C;EAC/C,UAAU;AACZ;;AAEA,sDAAsD;AACtD;EACE,cAAc;AAChB;;AAEA,kCAAkC;AAClC;EACE,kBAAkB;EAClB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,4BAA4B;AAC9B;;AAEA,2CAA2C;AAC3C,qCAAqC;AACrC;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA,kCAAkC;AAClC;EACE,4CAA4C;EAC5C,cAAc;EACd,kBAAkB;EAClB,YAAY;EACZ,eAAe;AACjB;;AAEA,gCAAgC;AAChC;EACE,aAAa;EACb,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;EACf,+CAA+C;EAC/C,UAAU;AACZ;;AAEA,sDAAsD;AACtD;EACE,cAAc;AAChB;;AAEA,kCAAkC;AAClC;EACE,YAAY;EACZ,kBAAkB;EAClB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,WAAW;EACX,aAAa;EACb,iBAAiB;EACjB,YAAY;AACd;;AAEA,2CAA2C;AAC3C;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,UAAU;EACV,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,UAAU;EACV,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,uCAAuC;EACvC,kBAAkB;EAClB,0BAA0B;EAC1B,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,OAAO;EACP,mBAAmB;EACnB,WAAW;EACX,kCAAkC;AACpC;;AAEA;EACE,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,0BAA0B;EAC1B,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,SAAS;EACT,WAAW;EACX,aAAa;AACf;;AAEA;EACE,eAAe;EACf,SAAS;EACT,WAAW;EACX,aAAa;AACf;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,6BAA6B;EAC7B,mBAAmB;EACnB,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,YAAY;AACd;;AAEA;EAIE,aAAa;EAEb,uBAAuB;EACvB,4CAA4C;EAC5C,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EAIE,aAAa;EAEb,uBAAuB;EACvB,4CAA4C;EAC5C,6BAA6B;EAC7B,sBAAsB;AACxB;;AAEA;EAIE,aAAa;EAEb,uBAAuB;EACvB,4CAA4C;EAC5C,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,0CAA0C;EAC1C,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,cAAc;EACd,WAAW;EACX,0CAA0C;EAC1C,uCAAuC;EACvC,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,wCAAwC;EACxC,4BAA4B;EAC5B,yCAAyC;EACzC,0BAA0B;EAC1B,8BAA8B;EAC9B,sBAAsB;EACtB,wEAAwE;EACxE,oCAAoC;EACpC,YAAY;AACd;;AAEA,gBAAgB;AAChB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;;AAGA;EACE,iCAAiC;EACjC,UAAU;AACZ;;AAEA;EACE,iCAAiC;EACjC,UAAU;AACZ;;AAEA,kCAAkC;AAClC,kCAAkC;AAClC,iBAAiB;AACjB,0BAA0B;AAC1B;EACE;IACE,eAAe;IACf,UAAU;IACV,SAAS;EACX;AACF;;AAEA,gCAAgC;AAChC;EACE;IACE,eAAe;IACf,UAAU;IACV,SAAS;EACX;AACF;;AAEA,2BAA2B;AAC3B;EACE;IACE,eAAe;IACf,UAAU;IACV,SAAS;EACX;AACF;;AAEA,6BAA6B;AAC7B;EACE;IACE,eAAe;IACf,UAAU;IACV,SAAS;EACX;AACF;;AAEA,gCAAgC;AAChC,4CAA4C;;AAE5C,cAAc;;AAEd;EACE,yBAAyB;EACzB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,UAAU;EACV,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;EAC7B,QAAQ;EACR,QAAQ;EACR,WAAW;EACX,uBAAuB;EACvB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,kCAAkC;EAClC,6BAA6B;EAC7B,YAAY;EACZ,eAAe;EACf,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,oCAAoC;EACpC,6BAA6B;AAC/B;;;AAGA;EACE,oCAAoC;EACpC,6BAA6B;AAC/B;;AAEA;EACE,oCAAoC;EACpC,6BAA6B;AAC/B;;AAEA;EACE,oCAAoC;EACpC,6BAA6B;AAC/B;;AAEA;EACE,oCAAoC;EACpC,6BAA6B;AAC/B;;AAEA;EACE,oCAAoC;EACpC,6BAA6B;AAC/B;;AAEA;EACE,oCAAoC;EACpC,6BAA6B;AAC/B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,4BAA4B;EAC5B,8BAA8B;EAC9B,iBAAiB;EACjB,yDAA4D;EAC5D,2BAA2B;AAC7B;;AAEA;EACE,6CAA6C;EAC7C,iCAAiC;EACjC,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;AACjB;;AAEA,uCAAuC;AACvC;;;EAGE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,SAAS;EACT,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,aAAa;EACb,aAAa;EACb,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,UAAU;EACV,kCAAkC;AACpC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,eAAe;EACf,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,+BAA+B;EAC/B,4BAA4B;EAC5B,oCAAoC;AACtC;;AAEA;EACE,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,8BAA8B;EAC9B,qDAAqD;EACrD,6BAA6B;EAC7B,2BAA2B;AAC7B;;AAEA;EACE,6CAA6C;EAC7C,2BAA2B;EAC3B,0BAA0B;EAC1B,oBAAoB;EACpB,0BAA0B;AAC5B;;AAEA;EACE,sBAAsB;EACtB,kCAAkC;AACpC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,iCAAiC;EACjC,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,YAAY;EACZ,eAAe;EACf,iCAAiC;EACjC,aAAa;EACb,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;AACV;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,0BAA0B;EAC1B,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;EACjC,2BAA2B;EAC3B,0BAA0B;EAC1B,4BAA4B;AAC9B;;AAEA;EACE,sBAAsB;AACxB;;;AAGA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,oBAAoB;EACpB,qBAAqB;EACrB,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,QAAQ;EACR,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,sBAAsB;EAEtB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,WAAW;EACX,SAAS;EACT,WAAW;EACX,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,UAAU;EACV,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,oBAAoB;EACpB,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,oBAAoB;EACpB,qBAAqB;EACrB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,0CAA0C;EAC1C,oCAAoC;EACpC,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,qBAAqB;EACrB,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,cAAc;EACd,OAAO;EACP,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,UAAU;EACV,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,oBAAoB;EACpB,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,sBAAsB;EACtB,uBAAuB;EACvB,qBAAqB;EACrB,+BAA+B;EAC/B,4BAA4B;EAC5B,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,6BAA6B;AAC/B;;;AAGA;EACE,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,4BAA4B;EAC5B,+BAA+B;EAC/B,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;;AAGA;EACE,UAAU;EACV,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,aAAa;EACb,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;EAOpC;;;mCAGiC;EACjC,4BAA4B;EAC5B,4CAA4C;AAC9C;;AAEA;EACE;IACE,6BAA6B;EAC/B;;EAEA;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE,QAAQ;EACR,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,QAAQ;EACR,OAAO;EACP,QAAQ;EACR,cAAc;EACd,WAAW;EACX,YAAY;EACZ,SAAS;AACX;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,QAAQ;EACR,OAAO;EACP,QAAQ;EACR,cAAc;EACd,eAAe;EACf,WAAW;EACX,YAAY;EACZ,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,MAAM;AACR;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,4BAA4B;EAC5B,6BAA6B;EAC7B,YAAY;EACZ,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,MAAM;EACN,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,UAAU;EACV,UAAU;EACV,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,UAAU;EACV,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE;IACE,WAAW;EACb;AACF;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,6BAA6B;EAC7B,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;EACnB,sDAAsD;AACxD;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,4CAA4C;EAC5C,kDAAkD;EAClD,oBAAoB;EACpB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,UAAU;EACV,mBAAmB;EACnB,yCAAyC;EACzC,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;EACnB,sDAAsD;AACxD;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,yBAAyB;EACzB,cAAc;EACd,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,aAAa;EACb,UAAU;EACV,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,oBAAoB;EACpB,yBAAyB;EACzB,qBAAqB;EACrB,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;AACd;;;AAGA;EACE,8BAA8B;EAC9B,uBAAuB;EACvB,2CAA2C;EAC3C,YAAY;AACd;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,qDAAqD;EACrD,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,qBAAqB;EACrB,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,SAAS;AACX;;AAEA;;EAEE,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,4CAA4C;AAC9C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,cAAc;EACd,oCAAoC;AACtC;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,cAAc;EACd,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,oCAAoC;EACpC,cAAc;EACd,gBAAgB;AAClB;;AAEA,oEAAoE;AACpE;EACE,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,2BAA2B;EAC3B,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,6BAA6B;EAC7B,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,2BAA2B;EAC3B,4CAA4C;AAC9C;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;AACjB;;AAEA,8BAA8B;AAC9B;EACE,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA,uBAAuB;AACvB;EACE,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,6BAA6B;EAC7B,8BAA8B;EAC9B,8BAA8B;EAC9B,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,yBAAyB;EACzB,yCAAyC;EACzC,eAAe;EACf,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,cAAc;EACd,eAAe;EACf,oBAAoB;AACtB;;AAEA,iBAAiB;AACjB;EACE,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,eAAe;EACf,cAAc;EACd,oBAAoB;AACtB;;AAEA,oBAAoB;AACpB;EACE,gCAAgC;EAChC,yDAAyD;AAC3D;;AAEA,mCAAmC;AACnC;EACE,4BAA4B;AAC9B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,0CAA0C;EAC1C,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,mBAAmB;EACnB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,cAAc;EACd,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,6BAA6B;EAC7B,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,0CAA0C;EAC1C,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,gCAAgC;EAChC,oBAAoB;AACtB;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EAGE,gBAAgB;EAChB,4BAA4B;EAC5B,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,0BAA0B;EAC1B,6CAA6C;EAC7C,cAAc;EACd,yDAAiJ;EACjJ,sCAAsC;EACtC,4BAA4B;AAC9B;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,6CAA6C;EAC7C,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,YAAY;EACZ,QAAQ;EACR,yBAAyB;EACzB,+CAA+C;AACjD;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,qDAAqD;EACrD,oBAAoB;EACpB,iDAAiD;EACjD,UAAU;EACV,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,2BAA2B;EAC3B,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,0CAA0C;EAC1C,aAAa;EACb,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,+BAA+B;AACjC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,UAAU;EACV,QAAQ;AACV;;;AAGA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,2BAA2B;EAC7B;AACF;;AAEA;;+EAE+E;;AAE/E;EACE,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,2CAA2C;AAC7C;;AAEA,0BAA0B;AAC1B;EACE,0CAA0C;EAC1C,oCAAoC;EACpC,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,iDAAiD;EACjD,kBAAkB;EAClB,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA;EACE,qBAAqB;EACrB,oCAAoC;EACpC,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,qBAAqB;EACrB,oCAAoC;EACpC,sBAAsB;EACtB,gDAAgD;AAClD;;AAEA,6CAA6C;AAC7C;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,+FAA+F;EAC/F,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,uCAAuC;EACvC,6FAA6F;AAC/F;;AAEA;EACE,+FAA+F;EAC/F,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,mBAAmB;AACnB;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,oCAAoC;EACpC,qCAAqC;EACrC,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,yBAAyB;AAC3B;;AAEA,4BAA4B;AAC5B;EACE,qCAAqC;EACrC,uCAAuC;EACvC,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,sCAAsC;EACtC,cAAc;AAChB;;AAEA,8BAA8B;AAC9B;EACE,gBAAgB;EAChB,sCAAsC;AACxC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,gDAAgD;AAChD;EACE,oCAAoC;EACpC,yCAAyC;EACzC,mBAAmB;EACnB,aAAa;EACb,yBAAyB;EACzB,0CAA0C;AAC5C;;AAEA;EACE,qCAAqC;EACrC,uCAAuC;AACzC;;AAEA;EACE,0CAA0C;EAC1C,2BAA2B;AAC7B;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA,sCAAsC;AACtC;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,yBAAyB;EACzB,eAAe;EACf,+BAA+B;EAC/B,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA,8BAA8B;AAC9B;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,WAAW;EACX,+BAA+B;EAC/B,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,mDAAmD;EACnD,4DAA4D;AAC9D;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,mCAAmC;AACnC;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;AACnB;;AAEA,iCAAiC;AACjC;EACE,yCAAyC;AAC3C;;AAEA;EACE,iDAAiD;AACnD;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA;EACE,OAAO,UAAU,EAAE,0BAA0B,EAAE;EAC/C,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC7C;;AAEA;EACE,WAAW,UAAU,EAAE;EACvB,MAAM,WAAW,EAAE;AACrB","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Poppins:wght@100;200;300;400;500;600;700;800;900&display=swap\");\r\n\r\n:root {\r\n  --admin-button-color: #0d6efd;\r\n  --warning-color: #ff2323;\r\n  --alert-color: #f8ff87;\r\n  --green-color: #00c07b;\r\n}\r\n\r\n.warningColor {\r\n  color: var(--warning-color) !important;\r\n}\r\n\r\n.alertColor {\r\n  color: var(--alert-color) !important;\r\n}\r\n\r\n.alertColorBg {\r\n  background-color: var(--alert-color) !important;\r\n}\r\n\r\n.warningColorBg {\r\n  background-color: var(--warning-color) !important;\r\n}\r\n\r\n.greenColorBg {\r\n  background-color: var(--green-color) !important;\r\n}\r\n\r\nbody {\r\n  font-family: \"Poppins\" !important;\r\n  background-color: #f0f0f0 !important;\r\n}\r\n\r\n/* Scrollbar Styling */\r\n::-webkit-scrollbar {\r\n  width: 6px;\r\n  height: 10px;\r\n}\r\n\r\n::-webkit-scrollbar-track {\r\n  background-color: #f0f0f0;\r\n  -webkit-border-radius: 10px;\r\n  border-radius: 10px;\r\n}\r\n\r\n::-webkit-scrollbar-thumb {\r\n  -webkit-border-radius: 10px;\r\n  border-radius: 10px;\r\n  background: #424242;\r\n}\r\n\r\n.card {\r\n  box-shadow: none !important;\r\n  border: none !important;\r\n}\r\n\r\n.iq-card {\r\n  box-shadow: none !important;\r\n}\r\n\r\nbutton,\r\np,\r\ninput,\r\nlabel,\r\nspan {\r\n  font-family: \"Poppins\";\r\n}\r\n\r\nh1,\r\nh2,\r\nh3,\r\nh4,\r\nh5,\r\nh6 {\r\n  font-family: \"Poppins\" !important;\r\n}\r\n\r\na {\r\n  text-decoration: none !important;\r\n}\r\n\r\n/* Style for the dropdown container */\r\n.editdropdown {\r\n  position: relative;\r\n  display: inline-block;\r\n  /* z-index: 9; */\r\n}\r\n\r\n/* Style for the dropdown button */\r\n.editdropdown-button {\r\n  /* background-color:  rgb(240, 240, 240) ; */\r\n  color: #000000;\r\n  padding: 10px 20px;\r\n  border: none;\r\n  cursor: pointer;\r\n}\r\n\r\n/* Style for the dropdown menu */\r\n.editdropdown-menu {\r\n  display: none;\r\n  left: -163px;\r\n  top: 0;\r\n  position: absolute;\r\n  background-color: #f9f9f9;\r\n  min-width: 190px;\r\n  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);\r\n  z-index: 1;\r\n}\r\n\r\n/* Show the dropdown menu when the button is clicked */\r\n.editdropdown:hover .editdropdown-menu {\r\n  display: block;\r\n}\r\n\r\n/* Style for dropdown menu items */\r\n.editdropdown-menu a {\r\n  padding: 12px 16px;\r\n  text-decoration: none;\r\n  display: block;\r\n}\r\n\r\n.mandatory {\r\n  color: red;\r\n}\r\n\r\n.mandatorySimple::after {\r\n  content: \"*\";\r\n  color: red;\r\n}\r\n\r\n.jodit_sticky>.jodit-toolbar__box {\r\n  position: inherit !important;\r\n}\r\n\r\n/* Highlight dropdown menu items on hover */\r\n/* Style for the dropdown container */\r\n.editdropdownpage {\r\n  position: relative;\r\n  display: inline-block;\r\n}\r\n\r\n/* Style for the dropdown button */\r\n.editdropdownpage-button {\r\n  /* background-color:  rgb(240, 240, 240) ; */\r\n  color: #000000;\r\n  padding: 10px 20px;\r\n  border: none;\r\n  cursor: pointer;\r\n}\r\n\r\n/* Style for the dropdown menu */\r\n.editdropdownpage-menu {\r\n  display: none;\r\n  left: -93px;\r\n  position: absolute;\r\n  background-color: #f9f9f9;\r\n  min-width: 100%;\r\n  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);\r\n  z-index: 1;\r\n}\r\n\r\n/* Show the dropdown menu when the button is clicked */\r\n.editdropdownpage:hover .editdropdownpage-menu {\r\n  display: block;\r\n}\r\n\r\n/* Style for dropdown menu items */\r\n.editdropdownpage-menu a {\r\n  color: black;\r\n  padding: 12px 16px;\r\n  text-decoration: none;\r\n  display: block;\r\n}\r\n\r\n.mandatory {\r\n  color: red;\r\n}\r\n\r\n.notificationofwednesday {\r\n  position: fixed;\r\n  width: 100%;\r\n  z-index: 9999;\r\n  background: black;\r\n  color: white;\r\n}\r\n\r\n/* Highlight dropdown menu items on hover */\r\n.editdropdownpage-menu a:hover {\r\n  background-color: #f1f1f1;\r\n}\r\n\r\n.green-color {\r\n  color: #d3ffd3;\r\n}\r\n\r\n.green-color-bg {\r\n  background-color: #d3ffd3;\r\n}\r\n\r\n.yellow-color {\r\n  color: #fff8a6;\r\n}\r\n\r\n.dark-green {\r\n  color: green;\r\n}\r\n\r\n.PUBLISHED_active {\r\n  background: #d3ffd3;\r\n  color: green;\r\n  font-weight: 600;\r\n  font-size: 13px;\r\n  border-radius: 20px;\r\n  width: 120px;\r\n}\r\n\r\n.UNPUBLISHED_active {\r\n  background: #ffd9d9;\r\n  color: red;\r\n  font-weight: 600;\r\n  font-size: 13px;\r\n  border-radius: 20px;\r\n  width: 120px;\r\n}\r\n\r\n.ACTIVE_active {\r\n  background: #d3ffd3;\r\n  color: green;\r\n  font-weight: 600;\r\n  font-size: 13px;\r\n  border-radius: 20px;\r\n  width: 120px;\r\n}\r\n\r\n.In-ACTIVE_active {\r\n  background: #ffd9d9;\r\n  color: red;\r\n  font-weight: 600;\r\n  font-size: 13px;\r\n  border-radius: 20px;\r\n  width: 120px;\r\n}\r\n\r\n.DISABLED_active {\r\n  background: #ffea008a;\r\n  color: #000000;\r\n  font-weight: 600;\r\n  font-size: 13px;\r\n  border-radius: 20px;\r\n  width: 120px;\r\n}\r\n\r\n.tabHeading {\r\n  font-family: \"museo_sans500\" !important;\r\n  font-style: normal;\r\n  font-size: 16px !important;\r\n  color: #424242 !important;\r\n  background-color: transparent;\r\n  position: relative;\r\n  display: block;\r\n}\r\n\r\n.tabHeading.active {\r\n  font-family: \"museo_sans700\" !important;\r\n}\r\n\r\n.tabHeading.active::after {\r\n  content: \"\";\r\n  position: absolute;\r\n  width: 100%;\r\n  bottom: -9px;\r\n  left: 0;\r\n  border-radius: 10px;\r\n  height: 4px;\r\n  background-color: rgb(77, 77, 247);\r\n}\r\n\r\n.dashboard a {\r\n  text-decoration: none;\r\n  font-size: 16px;\r\n}\r\n\r\n.dashboard p {\r\n  color: #000000;\r\n  font-family: 'Inter';\r\n  font-style: normal;\r\n  font-weight: 400;\r\n  font-size: 15px;\r\n  line-height: 18px;\r\n  text-transform: capitalize;\r\n  color: #161616;\r\n  font-style: normal;\r\n  font-weight: 400;\r\n  line-height: 25px;\r\n  color: #646464;\r\n}\r\n\r\n.liveAlert.alert.alert-success.alert-dismissible.fade.show {\r\n  position: fixed;\r\n  top: 10px;\r\n  right: 10px;\r\n  z-index: 9999;\r\n}\r\n\r\n.liveAlert.alert.alert-danger.alert-dismissible.fade.show {\r\n  position: fixed;\r\n  top: 10px;\r\n  right: 10px;\r\n  z-index: 9999;\r\n}\r\n\r\n.banner-slider .modal {\r\n  top: 50px;\r\n}\r\n\r\n.delete_confirm {\r\n  margin-top: 10rem;\r\n}\r\n\r\n.success-message i {\r\n  font-size: 50px;\r\n  background-color: transparent;\r\n  border-radius: 50px;\r\n  border: 2px solid greenyellow;\r\n  color: greenyellow;\r\n}\r\n\r\n.css-1u9des2-indicatorSeparator {\r\n  width: 0px !important;\r\n}\r\n\r\nselect {\r\n  height: 50px;\r\n}\r\n\r\n.css-1xc3v61-indicatorContainer {\r\n  display: -webkit-box;\r\n  display: -webkit-flex;\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  -webkit-transition: color 150ms;\r\n  transition: color 150ms;\r\n  color: hsl(0deg 3.96% 4.8% / 70%) !important;\r\n  padding: 0px !important;\r\n  box-sizing: border-box;\r\n}\r\n\r\n.css-15lsz6c-indicatorContainer {\r\n  display: -webkit-box;\r\n  display: -webkit-flex;\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  -webkit-transition: color 150ms;\r\n  transition: color 150ms;\r\n  color: hsl(0deg 3.96% 4.8% / 70%) !important;\r\n  /* padding: 0px !important; */\r\n  box-sizing: border-box;\r\n}\r\n\r\n.css-t3ipsp-control {\r\n  display: -webkit-box;\r\n  display: -webkit-flex;\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  -webkit-transition: color 150ms;\r\n  transition: color 150ms;\r\n  color: hsl(0deg 3.96% 4.8% / 70%) !important;\r\n  padding: 0px !important;\r\n  box-sizing: border-box;\r\n}\r\n\r\n.css-1xc3v61-indicatorContainer svg {\r\n  width: 30px !important;\r\n  height: 15px !important;\r\n  top: 14px !important;\r\n}\r\n\r\n.css-15lsz6c-indicatorContainer svg {\r\n  width: 18px !important;\r\n  height: 18px !important;\r\n}\r\n\r\n.css-15lsz6c-indicatorContainer svg.css-tj5bde-Svg {\r\n  position: absolute;\r\n  right: 10px;\r\n  top: 11px;\r\n}\r\n\r\n.css-b62m3t-container {\r\n  /* height: 50px; */\r\n  /* border: 1px solid #e5e5ea !important; */\r\n  border-radius: 5px;\r\n  align-items: center;\r\n  padding: 5px 0 5px 0;\r\n}\r\n\r\n.css-13cymwt-control {\r\n  min-height: 45px !important;\r\n}\r\n\r\n.thumbnails-images {\r\n  width: auto;\r\n  height: 100px;\r\n}\r\n\r\n.thumbnails-upload-images {\r\n  width: 100%;\r\n  height: 65px;\r\n}\r\n\r\n#publish_time {\r\n  display: block;\r\n  width: 100%;\r\n  padding: 0.375rem 2.25rem 0.375rem 0.75rem;\r\n  -moz-padding-start: calc(0.75rem - 3px);\r\n  font-size: 1rem;\r\n  font-weight: 400;\r\n  line-height: 1.5;\r\n  color: #212529;\r\n  background-color: transparent !important;\r\n  background-repeat: no-repeat;\r\n  background-position: right 0.75rem center;\r\n  background-size: 16px 12px;\r\n  border: transparent !important;\r\n  border-radius: 0.25rem;\r\n  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\r\n  border: 1px solid #e5e5ea !important;\r\n  height: 50px;\r\n}\r\n\r\n/* overlay.css */\r\n.overlay-container {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n  background-color: rgba(0, 0, 0, 0.5);\r\n  z-index: 9998;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n}\r\n\r\n.overlay-icon {\r\n  font-size: 25px;\r\n  color: white;\r\n}\r\n\r\n.css-1xc3v61-indicatorContainer svg.css-tj5bde-Svg {\r\n  position: absolute;\r\n  right: 0px;\r\n  top: 11px;\r\n}\r\n\r\n.css-1fdsijx-ValueContainer {\r\n  padding: auto !important;\r\n}\r\n\r\n.css-15lsz6c-indicatorContainer svg.css-tj5bde-Svg path[d=\"M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z\"] {\r\n  display: none;\r\n}\r\n\r\n.css-1xc3v61-indicatorContainer svg.css-tj5bde-Svg path[d=\"M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z\"] {\r\n  display: none;\r\n}\r\n\r\n\r\nth {\r\n  text-align-last: start !important;\r\n  padding: 0;\r\n}\r\n\r\ntd {\r\n  text-align-last: start !important;\r\n  padding: 0;\r\n}\r\n\r\n/* New Header siderbar 28/8/2023 */\r\n/* New Header siderbar 28/8/2023 */\r\n/* Mobile view  */\r\n/* Custom, iPhone Retina */\r\n@media only screen and (min-width: 320px) {\r\n  .footerlink {\r\n    font-size: 15px;\r\n    padding: 0;\r\n    margin: 0;\r\n  }\r\n}\r\n\r\n/* Extra Small Devices, Phones */\r\n@media only screen and (min-width: 480px) {\r\n  .footerlink {\r\n    font-size: 14px;\r\n    padding: 0;\r\n    margin: 0;\r\n  }\r\n}\r\n\r\n/* Small Devices, Tablets */\r\n@media only screen and (min-width: 768px) {\r\n  .footerlink {\r\n    font-size: 14px;\r\n    padding: 0;\r\n    margin: 0;\r\n  }\r\n}\r\n\r\n/* Medium Devices, Desktops */\r\n@media only screen and (min-width: 992px) {\r\n  .footerlink {\r\n    font-size: 14px;\r\n    padding: 0;\r\n    margin: 0;\r\n  }\r\n}\r\n\r\n/* Large Devices, Wide Screens */\r\n@media only screen and (min-width: 1200px) {}\r\n\r\n/* old codes */\r\n\r\n.errorred {\r\n  color: #ff2c2c !important;\r\n  font-size: 14px;\r\n  font-weight: 600;\r\n}\r\n\r\n.errorredspan {\r\n  position: absolute;\r\n  bottom: -18px;\r\n}\r\n\r\n.imageForm {\r\n  display: block;\r\n  position: absolute;\r\n  right: 16px;\r\n  z-index: 1;\r\n  bottom: 11px;\r\n  width: 80px;\r\n  height: 37px;\r\n  object-fit: cover;\r\n}\r\n\r\n#nestable>table {\r\n  overflow-x: auto;\r\n}\r\n\r\n.approveTable>table {\r\n  overflow-x: auto;\r\n}\r\n\r\n#videoPlayer {\r\n  width: 100%;\r\n  height: 100%;\r\n}\r\n\r\n.editVideoPlayer {\r\n  width: 125px !important;\r\n  height: 75px;\r\n}\r\n\r\n.status {\r\n  width: 80%;\r\n  font-weight: bold;\r\n  margin: 0 auto;\r\n  border-radius: 4px;\r\n}\r\n\r\n.closeBtn {\r\n  position: absolute !important;\r\n  right: 0;\r\n  top: 0px;\r\n  width: 40px;\r\n  background: transparent;\r\n  z-index: 100 !important;\r\n  height: 60px;\r\n}\r\n\r\n#PendingvideoPlayer {\r\n  width: 100%;\r\n  height: 80px;\r\n}\r\n\r\n.exportIcon {\r\n  width: 22px;\r\n  height: 18px;\r\n}\r\n\r\ninput[type=\"checkbox\"]:checked+label::before {\r\n  background-color: #00f;\r\n  border-color: #00f;\r\n}\r\n\r\n.idClass {\r\n  width: 80px !important;\r\n}\r\n\r\n.page-link {\r\n  transition: none !important;\r\n}\r\n\r\n.page-link:focus {\r\n  box-shadow: none !important;\r\n}\r\n\r\n.view-search {\r\n  background: rgba(250, 250, 250, 1);\r\n  border: 1px solid transparent;\r\n  height: 45px;\r\n  font-size: 14px;\r\n  width: 100%;\r\n  border-radius: 4px;\r\n  padding-left: 10px;\r\n  color: #646464 !important;\r\n}\r\n\r\n.filterContainer {\r\n  max-width: 270px;\r\n  width: 100%;\r\n  position: relative;\r\n}\r\n\r\n.hiddenExport {\r\n  display: none !important;\r\n}\r\n\r\n.video-overall-progress-li li {\r\n  list-style-type: none !important;\r\n}\r\n\r\n.filter:focus {\r\n  box-shadow: none !important;\r\n}\r\n\r\nselect#rating {\r\n  border: 1px solid #e5e5ea !important;\r\n  border-radius: 5px !important;\r\n}\r\n\r\n\r\nselect#trailer_type {\r\n  border: 1px solid #e5e5ea !important;\r\n  border-radius: 5px !important;\r\n}\r\n\r\nselect#access {\r\n  border: 1px solid #e5e5ea !important;\r\n  border-radius: 5px !important;\r\n}\r\n\r\nselect#url_type {\r\n  border: 1px solid #e5e5ea !important;\r\n  border-radius: 5px !important;\r\n}\r\n\r\nselect#parent_id {\r\n  border: 1px solid #e5e5ea !important;\r\n  border-radius: 5px !important;\r\n}\r\n\r\nselect#artist_type {\r\n  border: 1px solid #e5e5ea !important;\r\n  border-radius: 5px !important;\r\n}\r\n\r\nselect#role_id {\r\n  border: 1px solid #e5e5ea !important;\r\n  border-radius: 5px !important;\r\n}\r\n\r\nli {\r\n  list-style-type: none;\r\n}\r\n\r\n.form-control.filter {\r\n  max-width: 270px;\r\n  background-size: 18px;\r\n  background-repeat: no-repeat;\r\n  background-position: 11px 13px;\r\n  padding: 8px 37px;\r\n  background-image: url(\"./components/Images/search_lens.png\");\r\n  transition: none !important;\r\n}\r\n\r\n.totalText {\r\n  /* font-family: \"museo_sans700\" !important; */\r\n  font-family: \"Poppins\" !important;\r\n  font-style: normal;\r\n  color: #424242 !important;\r\n  font-size: 20px;\r\n}\r\n\r\n/* Shared Icon Positioning for Inputs */\r\n.lockIcon,\r\n.eyeOpen,\r\n.eyeClosed {\r\n  font-size: 18px;\r\n  color: #000;\r\n}\r\n\r\n.lockIcon {\r\n  top: 15px;\r\n  left: 10px;\r\n}\r\n\r\n.passWordIcon {\r\n  top: 15px;\r\n  right: 17px;\r\n}\r\n\r\n.react-bootstrap-table th.sortable {\r\n  position: relative;\r\n}\r\n\r\n.react-bs-table-no-data {\r\n  text-align: center;\r\n}\r\n\r\n.commonActionPadding {\r\n  padding: 12px 16px;\r\n  cursor: pointer;\r\n}\r\n\r\n.modal.packageModel {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  z-index: 9997;\r\n  display: none;\r\n  width: 100%;\r\n  height: 100%;\r\n  overflow-x: hidden;\r\n  overflow-y: auto;\r\n  outline: 0;\r\n  background-color: rgb(0 0 0 / 41%);\r\n}\r\n\r\n.modal.season.packageModel {\r\n  z-index: 9996 !important;\r\n}\r\n\r\n.packageModel .btn-close:focus {\r\n  box-shadow: none;\r\n}\r\n\r\n.noRecord {\r\n  display: flex;\r\n  justify-content: center;\r\n  font-size: 17px;\r\n  font-weight: bold;\r\n  padding: 10px;\r\n}\r\n\r\n.dropzone {\r\n  background-position: left;\r\n  background-size: 75% !important;\r\n  background-repeat: no-repeat;\r\n  justify-content: flex-end !important;\r\n}\r\n\r\n.editFormImage {\r\n  max-width: 170px !important;\r\n  height: 100px;\r\n  object-fit: contain;\r\n  display: block;\r\n  margin: 8px 0px;\r\n}\r\n\r\n.videoPreview {\r\n  width: 80%;\r\n  margin-right: auto;\r\n  height: 100%;\r\n}\r\n\r\n.Toastify__toast {\r\n  border-radius: 16px !important;\r\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12) !important;\r\n  padding: 12px 16px !important;\r\n  min-height: 56px !important;\r\n}\r\n\r\n.Toastify__toast-body {\r\n  font-family: \"Poppins\", sans-serif !important;\r\n  font-weight: 600 !important;\r\n  font-size: 14px !important;\r\n  margin: 0 !important;\r\n  padding: 0 12px !important;\r\n}\r\n\r\n.Toastify__toast-icon {\r\n  width: 22px !important;\r\n  margin-inline-end: 12px !important;\r\n}\r\n\r\n.Toastify__progress-bar {\r\n  height: 3px !important;\r\n}\r\n\r\n.admin-sub-title {\r\n  font-family: \"Poppins\";\r\n  font-size: 14px;\r\n  line-height: 15px;\r\n  font-weight: 600;\r\n  word-wrap: break-word;\r\n}\r\n\r\n.admin-sub-title {\r\n  font-family: \"Poppins\";\r\n  font-size: 14px;\r\n  line-height: 15px;\r\n  font-weight: 600;\r\n  word-wrap: break-word;\r\n}\r\n\r\n.bootstrapTable table>thead>tr {\r\n  border: none;\r\n}\r\n\r\n.bootstrapTable table>thead>tr>th {\r\n  border: none;\r\n  font-size: 16px;\r\n  font-family: \"Poppins\" !important;\r\n  padding: 10px;\r\n  width: 130px;\r\n  font-weight: 500;\r\n  position: relative;\r\n}\r\n\r\n.bootstrapTable table>tbody>tr>td {\r\n  white-space: normal;\r\n  word-break: break-all;\r\n  border: none;\r\n  font-size: 15px;\r\n  font-family: \"Poppins\" !important;\r\n  padding: 10px;\r\n  width: 130px;\r\n  vertical-align: middle;\r\n}\r\n\r\n.bootstrapTable.multi-delete-width table>thead>tr>th:nth-child(1) {\r\n  width: 4%;\r\n}\r\n\r\n.bootstrapTable .video-width-table {\r\n  width: 200px;\r\n}\r\n\r\n.bootstrapTable .page-item.disabled>.page-link {\r\n  opacity: 0.5;\r\n}\r\n\r\n.videoWidth>th:nth-child(2) {\r\n  width: 30%;\r\n  position: relative;\r\n}\r\n\r\n.videoWidthpartner>th:nth-child(2) {\r\n  width: 10%;\r\n  position: relative;\r\n}\r\n\r\n.videoWidth>th:nth-child(2) span {\r\n  position: absolute;\r\n  right: 0;\r\n}\r\n\r\n.videoWidth>th {\r\n  width: 100px;\r\n}\r\n\r\n.sortable::after {\r\n  content: \"\\2193\";\r\n  color: #ccc;\r\n  padding: 0px 9px;\r\n  position: absolute;\r\n  right: 12px;\r\n  top: 3px;\r\n  font-size: 18px;\r\n}\r\n\r\n.sortable::before {\r\n  content: \"\\2191\";\r\n  color: #ccc;\r\n  position: absolute;\r\n  right: 12px;\r\n  top: 3px;\r\n  font-size: 18px;\r\n}\r\n\r\nth[aria-label=\"Audios sort asc\"].sortable::before {\r\n  color: #0d6efd;\r\n}\r\n\r\nth[aria-label=\"Audios sort desc\"].sortable::after {\r\n  color: #0d6efd;\r\n}\r\n\r\nth[aria-label=\"Access sort asc\"].sortable::before {\r\n  color: #0d6efd;\r\n}\r\n\r\nth[aria-label=\"Access sort desc\"].sortable::after {\r\n  color: #0d6efd;\r\n}\r\n\r\nth[aria-label=\"Videos sort asc\"].sortable::before {\r\n  color: #0d6efd;\r\n}\r\n\r\nth[aria-label=\"Videos sort desc\"].sortable::after {\r\n  color: #0d6efd;\r\n}\r\n\r\nth[aria-label=\"Upload by sort asc\"].sortable::before {\r\n  color: #0d6efd;\r\n}\r\n\r\nth[aria-label=\"Upload sort desc\"].sortable::after {\r\n  color: #fff;\r\n}\r\n\r\n.profile {\r\n  width: 50px;\r\n  height: 50px;\r\n  object-fit: cover;\r\n  border-radius: 3px;\r\n}\r\n\r\n.table-subheading {\r\n  font-size: 12px;\r\n}\r\n\r\n.rightVideoTitle {\r\n  width: 200px;\r\n}\r\n\r\n.sliderBtnText {\r\n  font-size: 13px !important;\r\n  font-family: \"Poppins\" !important;\r\n}\r\n\r\n.admin-button-text {\r\n  font-family: \"Poppins\" !important;\r\n  font-weight: 600 !important;\r\n  font-size: 15px !important;\r\n  line-height: 20px !important;\r\n}\r\n\r\n.button-color {\r\n  color: #fff !important;\r\n}\r\n\r\n\r\n.admin-input-title {\r\n  font-size: 16px;\r\n  font-weight: 600;\r\n  line-height: 24px;\r\n}\r\n\r\n.svgIcon {\r\n  fill: none;\r\n  stroke: currentColor;\r\n  stroke-linecap: round;\r\n  stroke-linejoin: round;\r\n  stroke-width: 0.75px;\r\n}\r\n\r\n.bootstrapTable .react-bs-table-sizePerPage-dropdown .dropdown-menu {\r\n  bottom: 32px;\r\n}\r\n\r\n.bootstrapTable .react-bs-table-sizePerPage-dropdown .dropdown-item>a {\r\n  display: block;\r\n}\r\n\r\n#pageDropDown {\r\n  transition: none !important;\r\n}\r\n\r\n#pageDropDown:focus {\r\n  box-shadow: none !important;\r\n}\r\n\r\n.react-bootstrap-table-page-btns-ul {\r\n  justify-content: end;\r\n}\r\n\r\n.clearBtn {\r\n  top: 10px;\r\n  position: absolute;\r\n  right: 0;\r\n  background: transparent;\r\n}\r\n\r\n.custom-close-btn {\r\n  width: 20px;\r\n  height: 20px;\r\n  fill: currentColor;\r\n}\r\n\r\n.adminHeadContainer {\r\n  min-height: calc(100vh - 120px);\r\n}\r\n\r\n.slider {\r\n  position: absolute;\r\n  cursor: pointer;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  background-color: #ccc;\r\n  -webkit-transition: 0.6s;\r\n  transition: all 0.4s;\r\n}\r\n\r\n.slider.round {\r\n  border-radius: 34px;\r\n}\r\n\r\n.slider.round:before {\r\n  border-radius: 50%;\r\n}\r\n\r\ninput:checked+.slider {\r\n  background-color: #2196f3;\r\n}\r\n\r\ninput:focus+.slider {\r\n  box-shadow: 0 0 1px #2196f3;\r\n}\r\n\r\n.slider:before {\r\n  position: absolute;\r\n  content: \"\";\r\n  height: 15px;\r\n  width: 15px;\r\n  left: 4px;\r\n  bottom: 3px;\r\n  background-color: white;\r\n  transition: all 0.4s;\r\n}\r\n\r\ninput:checked+.slider:before {\r\n  left: 26px;\r\n}\r\n\r\n.switch {\r\n  position: relative;\r\n  display: inline-block;\r\n  width: 45px;\r\n  height: 20px;\r\n}\r\n\r\n.switch input {\r\n  opacity: 0;\r\n  width: 0;\r\n  height: 0;\r\n}\r\n\r\n.custom-placeholder::placeholder {\r\n  font-family: \"Poppins\" !important;\r\n}\r\n\r\n.imagedropcopy {\r\n  align-items: center;\r\n  justify-content: center;\r\n  border-radius: 5px;\r\n  border-style: dashed;\r\n  border-color: #cbd5e1;\r\n  cursor: pointer;\r\n  min-height: 70px;\r\n  height: auto;\r\n  width: 80%;\r\n}\r\n\r\n.imagedropcopyimage {\r\n  align-items: center;\r\n  justify-content: center;\r\n  border-radius: 5px;\r\n  border-style: dashed;\r\n  border-color: #cbd5e1;\r\n  width: 100%;\r\n  cursor: pointer;\r\n}\r\n\r\n.admin-title {\r\n  font-size: 30px;\r\n  line-height: 40px;\r\n  font-weight: bold;\r\n}\r\n\r\n.customDropWrapper {\r\n  width: 100%;\r\n  height: 250px;\r\n  border: 2px dashed rgba(99, 102, 241, 0.4);\r\n  background: rgba(99, 102, 241, 0.02);\r\n  position: relative;\r\n  border-radius: 16px;\r\n  transition: all 0.3s ease;\r\n  cursor: pointer;\r\n}\r\n\r\n.customDropWrapper input {\r\n  opacity: 0;\r\n}\r\n\r\n.customDropWrapper:hover {\r\n  border-color: #6366f1;\r\n  background: rgba(99, 102, 241, 0.05);\r\n}\r\n\r\n.dropZoneText {\r\n  position: absolute;\r\n  top: 0;\r\n  margin: 0 auto;\r\n  left: 0;\r\n  right: 0;\r\n  height: 100%;\r\n}\r\n\r\n.rowCheckboxDrag {\r\n  width: 4% !important;\r\n}\r\n\r\n.rowCheckboxfooterDrag {\r\n  width: 9% !important;\r\n}\r\n\r\n.category-order-title {\r\n  padding: 10px;\r\n  font-size: 16px;\r\n  white-space: normal;\r\n  word-break: break-all;\r\n  border: none;\r\n}\r\n\r\n.border-width {\r\n  border-width: 2px !important;\r\n}\r\n\r\n.border-solid-width {\r\n  border-width: 1px;\r\n}\r\n\r\n.orderHeading {\r\n  font-size: 16px;\r\n  font-weight: bold;\r\n  line-height: 37px;\r\n  font-family: 'Poppins';\r\n}\r\n\r\n.orderContainer>div:not(:nth-child(2), :nth-child(1), :nth-child(4)) {\r\n  width: 15%;\r\n}\r\n\r\n.orderContainer>div:nth-child(1) {\r\n  width: 5%;\r\n}\r\n\r\n.orderContainer>div:nth-child(2) {\r\n  width: 25%;\r\n}\r\n\r\n.orderContainer>div:nth-child(4) {\r\n  width: 15%;\r\n}\r\n\r\n.reloadButton {\r\n  width: 35px;\r\n  height: 35px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n.custom-tool-tip-parent {\r\n  position: relative;\r\n}\r\n\r\n.custom-tool-tip-parent:hover .custom-tool-tip {\r\n  display: block !important;\r\n}\r\n\r\n.cursor-pointer {\r\n  cursor: pointer;\r\n}\r\n\r\n.modal-description {\r\n  font-size: 14px;\r\n  line-height: 20px;\r\n  font-weight: 500;\r\n}\r\n\r\n.imagedrop {\r\n  /* width: 100%; */\r\n  width: 80%;\r\n  height: 70px;\r\n  /* height: 120px; */\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  border-radius: 5px;\r\n  border-style: dashed;\r\n  border-color: #cbd5e1;\r\n  cursor: pointer;\r\n}\r\n\r\n.image-close {\r\n  position: absolute;\r\n  top: -16px;\r\n  right: -14px;\r\n  width: 22px !important;\r\n  height: 22px !important;\r\n  opacity: 1 !important;\r\n  border-style: dashed !important;\r\n  border-width: 2px !important;\r\n  border-color: #cbd5e1 !important;\r\n}\r\n\r\n.custom-input {\r\n  font-size: 13px;\r\n  padding: 15px 20px;\r\n  border-radius: 7px;\r\n  font-weight: 500;\r\n}\r\n\r\ninput[readonly]:focus {\r\n  outline: none;\r\n}\r\n\r\n.focus-hide:focus {\r\n  outline: 0;\r\n}\r\n\r\n.rti--container {\r\n  padding: 11px 15px !important;\r\n}\r\n\r\n.rti--tag>span {\r\n  padding: 4px 15px;\r\n  border-radius: 2px;\r\n}\r\n\r\n.rti--tag>button {\r\n  padding: 3px 5px !important;\r\n  border-radius: 0px !important;\r\n}\r\n\r\n\r\n.admin-input-description {\r\n  font-size: 13px;\r\n  min-width: 80px;\r\n}\r\n\r\n.copy-board-container {\r\n  cursor: pointer;\r\n  position: absolute;\r\n  top: -1px;\r\n  width: 55px;\r\n  right: -1px;\r\n  border-top-right-radius: 9px;\r\n  border-bottom-right-radius: 9px;\r\n  height: 51px;\r\n}\r\n\r\n.copy-board-input {\r\n  padding-right: 55px;\r\n}\r\n\r\n\r\n.copy-reply {\r\n  top: -45px;\r\n  right: 6px;\r\n}\r\n\r\n.tool-tip-text {\r\n  top: -44px;\r\n  padding: 10px;\r\n  left: 136px;\r\n  font-size: 10px;\r\n  border-radius: 6px;\r\n  width: 180px;\r\n  line-height: 15px;\r\n}\r\n\r\n.tool-tip-open:hover .tool-tip-text {\r\n  display: block !important;\r\n}\r\n\r\n.labelLoader {\r\n  width: 30%;\r\n  height: 20px;\r\n  border-radius: 3px;\r\n}\r\n\r\n.headingLoader {\r\n  width: 50%;\r\n  height: 35px;\r\n  border-radius: 3px;\r\n}\r\n\r\n.subHeadingLoader {\r\n  width: 40%;\r\n  height: 14px;\r\n  border-radius: 3px;\r\n}\r\n\r\n.square {\r\n  background: rgba(130, 130, 130, 0.2);\r\n  background: -webkit-gradient(linear,\r\n      left top,\r\n      right top,\r\n      color-stop(8%, rgba(130, 130, 130, 0.2)),\r\n      color-stop(18%, rgba(130, 130, 130, 0.3)),\r\n      color-stop(33%, rgba(130, 130, 130, 0.2)));\r\n  background: linear-gradient(to right,\r\n      rgba(130, 130, 130, 0.2) 8%,\r\n      rgba(130, 130, 130, 0.3) 18%,\r\n      rgba(130, 130, 130, 0.2) 33%);\r\n  background-size: 800px 100px;\r\n  animation: wave-squares 2s infinite ease-out;\r\n}\r\n\r\n@keyframes wave-squares {\r\n  0% {\r\n    background-position: -468px 0;\r\n  }\r\n\r\n  100% {\r\n    background-position: 468px 0;\r\n  }\r\n}\r\n\r\n.cancal-position {\r\n  top: 2px;\r\n  right: 5px;\r\n}\r\n\r\n.cancal-position>svg {\r\n  width: 15px;\r\n  height: 15px;\r\n}\r\n\r\n.progressHeight {\r\n  height: 30px;\r\n}\r\n\r\n.percentagePop {\r\n  top: 5px;\r\n  left: 0;\r\n  right: 0;\r\n  margin: 0 auto;\r\n  width: 20px;\r\n  height: 10px;\r\n  border: 0;\r\n}\r\n\r\n.progressSmall {\r\n  height: 15px;\r\n}\r\n\r\n.progressSubText {\r\n  font-size: 13px;\r\n  font-weight: 500;\r\n  margin-bottom: 3px;\r\n}\r\n\r\n.progressButton {\r\n  font-size: 10px;\r\n  padding: 3px 13px;\r\n}\r\n\r\n.percentageText {\r\n  top: 0px;\r\n  left: 0;\r\n  right: 0;\r\n  margin: 0 auto;\r\n  font-size: 11px;\r\n  width: 20px;\r\n  height: 14px;\r\n  border: 0;\r\n}\r\n\r\n.progressFileNameElip {\r\n  width: 110px;\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n}\r\n\r\n.modal-large {\r\n  max-width: 800px !important;\r\n}\r\n\r\n.priceTable {\r\n  height: 300px;\r\n  overflow-y: overlay;\r\n}\r\n\r\n.priceTable thead {\r\n  position: sticky;\r\n  top: 0;\r\n}\r\n\r\n.AdminUploadIndicator {\r\n  position: fixed;\r\n  bottom: 50px;\r\n  right: 10px;\r\n  width: 400px;\r\n  z-index: 998;\r\n  border-top-left-radius: 25px;\r\n  border-top-right-radius: 25px;\r\n  height: auto;\r\n  max-height: 450px;\r\n  transition: height 1s ease;\r\n}\r\n\r\n.overflow-scroll-indicator {\r\n  overflow: hidden overlay;\r\n}\r\n\r\n.overflow-hidden-indicator {\r\n  overflow-x: hidden !important;\r\n}\r\n\r\n.upload-indicator-header {\r\n  top: 0;\r\n  z-index: 998;\r\n}\r\n\r\n.AdminUploadIndicator.collapse-zone {\r\n  height: 50px;\r\n}\r\n\r\n.indicator-width {\r\n  width: 200px;\r\n}\r\n\r\n.successFull {\r\n  background-color: #3cb043;\r\n}\r\n\r\n.indicator-file-name {\r\n  width: 200px;\r\n  height: 20px;\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n}\r\n\r\n.indicatorButon {\r\n  width: 58px;\r\n}\r\n\r\n.list-height {\r\n  height: 68px;\r\n}\r\n\r\n.cancelText {\r\n  font-size: 10px;\r\n}\r\n\r\n.sizeText {\r\n  font-size: 10px;\r\n  font-weight: bold;\r\n}\r\n\r\n.speedText {\r\n  font-size: 10px;\r\n  font-weight: 600;\r\n}\r\n\r\n.border-solid {\r\n  border-style: solid;\r\n}\r\n\r\n.rotate-arrow {\r\n  transform: rotate(180deg);\r\n}\r\n\r\n.from-indicator {\r\n  padding: 2px 9px;\r\n  font-size: 8px;\r\n  top: -11px;\r\n  left: -2px;\r\n  background-color: rgb(241, 241, 115);\r\n}\r\n\r\n.galleryBox {\r\n  height: 400px;\r\n  overflow-y: scroll;\r\n}\r\n\r\n.galleryImage {\r\n  height: 150px;\r\n  object-fit: cover;\r\n}\r\n\r\n.galleryTitle {\r\n  font-size: 13px;\r\n  font-weight: 500;\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  line-height: 20px;\r\n}\r\n\r\n.galleryDuration {\r\n  font-size: 11px;\r\n  font-weight: 400;\r\n}\r\n\r\n.galleryButton {\r\n  width: 30px;\r\n  height: 30px;\r\n}\r\n\r\n.galleryAfter::after {\r\n  content: '' !important;\r\n  display: none !important;\r\n}\r\n\r\n.galleryCheckBox {\r\n  position: absolute;\r\n  top: 38px;\r\n  left: 37px;\r\n  height: 21px;\r\n  width: 21px;\r\n}\r\n\r\n.hideArrow::after {\r\n  border: none !important;\r\n}\r\n\r\n.custom-datepicker {\r\n  width: 250;\r\n  border: 1px solid #ccc;\r\n  border-radius: 6px;\r\n}\r\n\r\n.custom-datepicker .rs-picker-toggle-value {\r\n  color: black !important;\r\n}\r\n\r\n.rs-picker-daterange-header {\r\n  display: none !important;\r\n}\r\n\r\n.z-index-1 {\r\n  z-index: 1;\r\n}\r\n\r\n.table-column-title.avoid-overflow-ellipsis {\r\n  text-overflow: unset;\r\n  overflow: unset;\r\n  white-space: unset;\r\n  max-width: unset;\r\n}\r\n\r\n@media screen and (max-width: 423px) {\r\n  .deleteBtn {\r\n    width: 100%;\r\n  }\r\n}\r\n\r\n.tooltip-disabled {\r\n  font-size: 11px;\r\n  background-color: #333;\r\n  color: #fff;\r\n  padding: 5px 8px;\r\n  border-radius: 4px;\r\n  white-space: nowrap;\r\n  z-index: 9999 !important;\r\n}\r\n\r\n.custom-page-select {\r\n  background-color: #ffffff;\r\n  color: #000;\r\n}\r\n\r\nselect.select-view-type {\r\n  width: 100px !important;\r\n}\r\n\r\n.admin-tooltip {\r\n  border-radius: 6px;\r\n  white-space: nowrap;\r\n  transition: opacity 0.2s ease;\r\n  pointer-events: none;\r\n}\r\n\r\n.tooltip-container:hover .admin-tooltip {\r\n  pointer-events: auto;\r\n}\r\n\r\n.admin-tooltip::after {\r\n  content: \"\";\r\n  position: absolute;\r\n  top: 100%;\r\n  left: 50%;\r\n  margin-left: -5px;\r\n  border-width: 5px;\r\n  border-style: solid;\r\n  border-color: #000 transparent transparent transparent;\r\n}\r\n\r\n.tooltip-container .custom-hover-tooltip {\r\n  opacity: 0;\r\n  visibility: hidden;\r\n  transform: translateX(-50%) translateY(10px);\r\n  transition: opacity 0.2s ease, transform 0.2s ease;\r\n  pointer-events: none;\r\n  position: absolute;\r\n  z-index: 9999;\r\n}\r\n\r\n.tooltip-container:hover .custom-hover-tooltip {\r\n  opacity: 1;\r\n  visibility: visible;\r\n  transform: translateX(-50%) translateY(0);\r\n  pointer-events: auto;\r\n}\r\n\r\n.custom-hover-tooltip::after {\r\n  content: \"\";\r\n  position: absolute;\r\n  top: 100%;\r\n  left: 50%;\r\n  margin-left: -5px;\r\n  border-width: 5px;\r\n  border-style: solid;\r\n  border-color: #000 transparent transparent transparent;\r\n}\r\n\r\n.trailer-episode-image {\r\n  height: 50px;\r\n  width: 50px;\r\n  object-fit: cover;\r\n}\r\n\r\n.rtmpurleditbg :hover {\r\n  background-color: rgb(245, 247, 252) !important;\r\n}\r\n\r\n.logoPay {\r\n  width: 160px;\r\n  height: 50px;\r\n  object-fit: contain;\r\n}\r\n\r\n.drag-handle {\r\n  cursor: grab;\r\n  user-select: none;\r\n}\r\n\r\n.modalBackdropdataserviceunavailable {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  background-color: #000000;\r\n  color: #ffffff;\r\n  opacity: 0.8;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  z-index: 10007;\r\n}\r\n\r\n.modalContentdataserviceunavailable {\r\n  background-color: #000000;\r\n  color: #ffffff;\r\n  padding: 2rem;\r\n  opacity: 1;\r\n  border-radius: 10px;\r\n  max-width: 700px;\r\n  text-align: center;\r\n}\r\n\r\n.hide-checkbox-row td input[type=\"checkbox\"] {\r\n  display: none !important;\r\n}\r\n\r\n.counter_timing {\r\n  border-radius: 0.8em;\r\n  -moz-border-radius: 0.8em;\r\n  display: inline-block;\r\n  line-height: 1.6em;\r\n  margin-left: 20px;\r\n  text-align: center;\r\n  width: 1.6em;\r\n}\r\n\r\n\r\n.modern-modal {\r\n  border-radius: 20px !important;\r\n  padding: 10px 10px 20px;\r\n  box-shadow: 0 15px 35px rgba(0, 0, 0, 0.20);\r\n  border: none;\r\n}\r\n\r\n.modern-backdrop {\r\n  backdrop-filter: blur(4px);\r\n}\r\n\r\n.upgrade-btn {\r\n  background: linear-gradient(135deg, #ff8a00, #ff4d00);\r\n  color: #fff !important;\r\n  padding: 12px;\r\n  border-radius: 12px;\r\n  font-weight: 600;\r\n  text-decoration: none;\r\n  display: inline-block;\r\n  transition: 0.2s ease;\r\n}\r\n\r\n.upgrade-btn:hover {\r\n  opacity: 0.9;\r\n}\r\n\r\n.modal-title {\r\n  font-size: 1.25rem;\r\n}\r\n\r\n.sub-page {\r\n  display: grid;\r\n  grid-template-columns: 3fr 1.3fr;\r\n  gap: 24px;\r\n}\r\n\r\n.sub-card,\r\n.checkout-card {\r\n  background: #fff;\r\n  border-radius: 10px;\r\n  padding: 20px 24px;\r\n  box-shadow: 0 2px 8px rgba(15, 23, 42, 0.05);\r\n}\r\n\r\n.sub-title {\r\n  font-size: 26px;\r\n  font-weight: 800;\r\n  margin-bottom: 8px;\r\n  color: #111827;\r\n  letter-spacing: -0.5px;\r\n}\r\n\r\n.sub-tabs {\r\n  display: flex;\r\n  gap: 24px;\r\n  border-bottom: 1px solid #e5e7eb;\r\n}\r\n\r\n.tab {\r\n  padding: 10px 0;\r\n  border: none;\r\n  background: none;\r\n  cursor: pointer;\r\n  font-size: 14px;\r\n  color: #6b7280;\r\n  border-bottom: 2px solid transparent;\r\n}\r\n\r\n.tab.active {\r\n  color: #111827;\r\n  font-weight: 600;\r\n  border-color: #2563eb;\r\n}\r\n\r\n.tab-body {\r\n  padding-top: 20px;\r\n}\r\n\r\n.section-title {\r\n  font-size: 18px;\r\n  font-weight: 600;\r\n  margin-bottom: 16px;\r\n}\r\n\r\n.subscription-row {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  margin-bottom: 16px;\r\n}\r\n\r\n.row {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  margin-bottom: 8px;\r\n  font-size: 14px;\r\n}\r\n\r\n.label {\r\n  font-weight: 600;\r\n  color: #374151;\r\n}\r\n\r\n.badge {\r\n  background: #e5edff;\r\n  color: #2563eb;\r\n  padding: 4px 10px;\r\n  border-radius: 999px;\r\n  font-size: 12px;\r\n}\r\n\r\n.status-pill {\r\n  margin-left: auto;\r\n  background: #dcfce7;\r\n  color: #15803d;\r\n  padding: 4px 10px;\r\n  border-radius: 999px;\r\n  font-size: 12px;\r\n}\r\n\r\n.plans-grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));\r\n  gap: 16px;\r\n}\r\n\r\n.plan-card {\r\n  border: 1px solid #e5e7eb;\r\n  border-radius: 8px;\r\n  padding: 12px 14px;\r\n}\r\n\r\n.plan-head {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  margin-bottom: 8px;\r\n}\r\n\r\n.plan-price {\r\n  display: flex;\r\n  align-items: baseline;\r\n  gap: 4px;\r\n}\r\n\r\n.price {\r\n  font-size: 18px;\r\n  font-weight: 600;\r\n}\r\n\r\n.cycle {\r\n  font-size: 12px;\r\n  color: #6b7280;\r\n}\r\n\r\n.btn-outline {\r\n  margin-top: 8px;\r\n  width: 100%;\r\n  padding: 8px 0;\r\n  border-radius: 6px;\r\n  border: 1px solid #2563eb;\r\n  background: #fff;\r\n  color: #2563eb;\r\n  cursor: pointer;\r\n}\r\n\r\n.checkout-card h3 {\r\n  font-size: 18px;\r\n  font-weight: 600;\r\n  margin-bottom: 16px;\r\n}\r\n\r\n.total-row span:last-child {\r\n  font-weight: 700;\r\n}\r\n\r\n.btn-primary.full {\r\n  margin-top: 20px;\r\n  width: 100%;\r\n  padding: 10px 0;\r\n  border-radius: 6px;\r\n  border: none;\r\n  background: #2563eb;\r\n  color: #fff;\r\n  cursor: pointer;\r\n}\r\n\r\n.addons-section {\r\n  margin-bottom: 24px;\r\n}\r\n\r\n.plans-grid.compact {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  gap: 12px;\r\n  row-gap: 10px;\r\n}\r\n\r\n.pricing-card.small {\r\n  flex: 0 0 240px;\r\n  max-width: 240px;\r\n  border: 1px solid #e5e7eb;\r\n  border-radius: 14px;\r\n  padding: 16px;\r\n  background: #fff;\r\n  cursor: pointer;\r\n  transition: 0.2s ease;\r\n}\r\n\r\n.addons-title {\r\n  font-size: 16px;\r\n  font-weight: 600;\r\n  margin-bottom: 12px;\r\n}\r\n\r\n.addon-card {\r\n  border: 1px solid #e5e7eb;\r\n  border-radius: 8px;\r\n  padding: 12px 14px;\r\n  margin-bottom: 10px;\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  transition: all 0.2s ease-in-out;\r\n}\r\n\r\n.addon-card.purchased {\r\n  background: #f0fdf4;\r\n  border-color: #bbf7d0;\r\n}\r\n\r\n.addon-name {\r\n  margin: 0;\r\n  font-size: 15px;\r\n  font-weight: 600;\r\n}\r\n\r\n.addon-price {\r\n  margin: 0;\r\n  font-size: 13px;\r\n  color: #6b7280;\r\n}\r\n\r\n.purchased-badge {\r\n  background: #059669;\r\n  color: white;\r\n  padding: 4px 10px;\r\n  border-radius: 999px;\r\n  font-size: 12px;\r\n}\r\n\r\n.btn-outline-danger {\r\n  margin-top: 8px;\r\n  width: 100px;\r\n  padding: 8px 0;\r\n  border-radius: 6px;\r\n  border: 1px solid #dc2626;\r\n  color: #dc2626;\r\n  background: #fff;\r\n  cursor: pointer;\r\n}\r\n\r\n.save-tag {\r\n  font-size: 11px;\r\n  padding: 2px 6px;\r\n  border-radius: 999px;\r\n  background: rgba(16, 185, 129, 0.14);\r\n  color: #047857;\r\n  font-weight: 600;\r\n}\r\n\r\n/* Existing pricing card styles (keep yours, add tweaks if needed) */\r\n.pricing-card.small {\r\n  width: 260px;\r\n  border: 1px solid #e5e7eb;\r\n  border-radius: 14px;\r\n  padding: 18px;\r\n  background: #fff;\r\n  cursor: pointer;\r\n  transition: 0.2s ease;\r\n}\r\n\r\n.pricing-card.small:hover {\r\n  transform: translateY(-3px);\r\n  border-color: #2563eb;\r\n  box-shadow: 0 10px 25px rgba(15, 23, 42, 0.07);\r\n}\r\n\r\n.pricing-card.small.active {\r\n  border: 2px solid #2563eb;\r\n  background: #eef4ff;\r\n}\r\n\r\n.card-top {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  margin-bottom: 14px;\r\n}\r\n\r\n.plan-name {\r\n  font-size: 18px;\r\n  font-weight: 700;\r\n  margin: 0;\r\n}\r\n\r\n.plan-icon {\r\n  font-size: 22px;\r\n  color: #9ca3af;\r\n}\r\n\r\n.selected-icon {\r\n  font-size: 22px;\r\n  color: #2563eb;\r\n}\r\n\r\n.price-block {\r\n  margin-top: 10px;\r\n}\r\n\r\n.price-main {\r\n  font-size: 26px;\r\n  font-weight: 800;\r\n}\r\n\r\n.cycle {\r\n  font-size: 15px;\r\n  color: #6b7280;\r\n  margin-left: 4px;\r\n}\r\n\r\n.price-strike {\r\n  margin-top: 3px;\r\n  text-decoration: line-through;\r\n  color: #9ca3af;\r\n  font-size: 15px;\r\n}\r\n\r\n.addon-card:hover {\r\n  transform: translateY(-3px);\r\n  box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.08);\r\n}\r\n\r\n.modern-select select {\r\n  padding-left: 36px;\r\n  border-radius: 10px;\r\n  font-size: 15px;\r\n}\r\n\r\n/* Wrapper prevents clipping */\r\n.dropdown-wrapper {\r\n  position: relative;\r\n  overflow: visible !important;\r\n}\r\n\r\n/* Dropdown container */\r\n.custom-dropdown {\r\n  position: relative;\r\n  width: 220px;\r\n}\r\n\r\n.dd-select {\r\n  padding-left: 40px !important;\r\n  padding-right: 40px !important;\r\n  border-radius: 12px !important;\r\n  height: 42px;\r\n  font-size: 15px;\r\n  background: #ffffff;\r\n  border: 1px solid #dcdcdc;\r\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);\r\n  cursor: pointer;\r\n  appearance: none;\r\n  /* Hide default arrow */\r\n}\r\n\r\n/* Funnel icon */\r\n.dd-icon {\r\n  position: absolute;\r\n  left: 12px;\r\n  top: 50%;\r\n  transform: translateY(-50%);\r\n  color: #6c757d;\r\n  font-size: 16px;\r\n  pointer-events: none;\r\n}\r\n\r\n/* Custom arrow */\r\n.custom-dropdown::after {\r\n  content: \"▼\";\r\n  position: absolute;\r\n  right: 12px;\r\n  top: 50%;\r\n  transform: translateY(-50%);\r\n  font-size: 10px;\r\n  color: #6c757d;\r\n  pointer-events: none;\r\n}\r\n\r\n/* Focus highlight */\r\n.dd-select:focus {\r\n  border-color: #4e74ff !important;\r\n  box-shadow: 0 0 0 3px rgba(78, 116, 255, 0.25) !important;\r\n}\r\n\r\n/* Ensure dropdown never gets cut */\r\nselect {\r\n  overflow: visible !important;\r\n}\r\n\r\n.dropdown-menu {\r\n  z-index: 9999 !important;\r\n}\r\n\r\n.subscription-container {\r\n  background: #ffffff;\r\n  border-radius: 14px;\r\n  padding: 28px;\r\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.04);\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 24px;\r\n}\r\n\r\n.sub-header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n}\r\n\r\n.sub-title {\r\n  font-size: 22px;\r\n  font-weight: 700;\r\n  color: #111827;\r\n}\r\n\r\n.status-badge {\r\n  padding: 6px 14px;\r\n  font-size: 13px;\r\n  border-radius: 12px;\r\n  background: #e0fbe8;\r\n  color: #15803d;\r\n  font-weight: 600;\r\n}\r\n\r\n.plan-card-modern {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  background: #f8f9ff;\r\n  border: 1px solid #e1e6ff;\r\n  padding: 18px 20px;\r\n  border-radius: 12px;\r\n}\r\n\r\n.plan-label {\r\n  font-size: 13px;\r\n  color: #6b7280;\r\n  margin-bottom: 2px;\r\n}\r\n\r\n.plan-name {\r\n  font-size: 20px;\r\n  font-weight: 700;\r\n  color: #1e3a8a;\r\n}\r\n\r\n.plan-tag {\r\n  padding: 6px 14px;\r\n  font-size: 12px;\r\n  background: #eef2ff;\r\n  color: #4338ca;\r\n  border-radius: 12px;\r\n  font-weight: 600;\r\n}\r\n\r\n.info-grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));\r\n  gap: 18px;\r\n}\r\n\r\n.info-item {\r\n  background: #fafafa;\r\n  border: 1px solid #f0f0f0;\r\n  padding: 14px 16px;\r\n  border-radius: 12px;\r\n}\r\n\r\n.info-item.full {\r\n  grid-column: 1 / -1;\r\n}\r\n\r\n.info-label {\r\n  font-size: 12px;\r\n  text-transform: uppercase;\r\n  color: #6b7280;\r\n  letter-spacing: 0.5px;\r\n  margin-bottom: 4px;\r\n  font-weight: 600;\r\n}\r\n\r\n.info-value {\r\n  font-size: 15px;\r\n  font-weight: 600;\r\n  color: #111827;\r\n}\r\n\r\n.divider {\r\n  border: none;\r\n  border-top: 1px solid #e5e7eb;\r\n  margin: 10px 0;\r\n}\r\n\r\n.checkout-card-modern {\r\n  background: #ffffff;\r\n  border-radius: 14px;\r\n  padding: 20px 22px;\r\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);\r\n  border: 1px solid #f0f2f5;\r\n}\r\n\r\n.checkout-title {\r\n  font-size: 19px;\r\n  font-weight: 600;\r\n  margin-bottom: 15px;\r\n}\r\n\r\n.checkout-row {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  padding: 6px 0;\r\n  font-size: 14px;\r\n}\r\n\r\n.value {\r\n  font-weight: 600;\r\n}\r\n\r\n.total-row .value.total {\r\n  font-size: 18px;\r\n  color: #111;\r\n  font-weight: 700;\r\n}\r\n\r\n.divider-light {\r\n  border-top: 1px dashed #ddd;\r\n  margin: 10px 0;\r\n}\r\n\r\n.highlight-row {\r\n  background: #f9f2ff;\r\n  padding: 8px 10px;\r\n  border-radius: 8px;\r\n  font-weight: 600;\r\n  color: #6a00ff;\r\n}\r\n\r\n.subtle-row {\r\n  color: #555;\r\n  font-size: 13.5px;\r\n}\r\n\r\n.next-billing-text {\r\n  margin-top: 6px;\r\n  font-size: 12.5px;\r\n  color: #666;\r\n}\r\n\r\n.cancel-btn {\r\n  background: #e63946;\r\n  color: white;\r\n  padding: 10px 18px;\r\n  border-radius: 8px;\r\n  border: none;\r\n  font-size: 14px;\r\n  cursor: pointer;\r\n  margin-top: 20px;\r\n}\r\n\r\n.cancel-btn:hover {\r\n  background: #d62828;\r\n}\r\n\r\n.disabled-card {\r\n  cursor: not-allowed !important;\r\n  border-color: #d1d5db !important;\r\n  pointer-events: none;\r\n}\r\n\r\n.disabled-card:hover {\r\n  transform: none !important;\r\n  box-shadow: none !important;\r\n}\r\n\r\n.purchased-pill {\r\n  background: #10b981;\r\n  color: #fff;\r\n  padding: 4px 10px;\r\n  border-radius: 999px;\r\n  font-size: 12px;\r\n  font-weight: 600;\r\n  display: inline-block;\r\n}\r\n\r\n.pricing-header-v3 {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  margin-bottom: 28px;\r\n}\r\n\r\n.pricing-title-v3 {\r\n  font-size: 26px;\r\n  font-weight: 700;\r\n  color: #0f172a;\r\n}\r\n\r\n.pricing-subtitle-v3 {\r\n  font-size: 14px;\r\n  color: #64748b;\r\n  margin-top: 4px;\r\n}\r\n\r\n.pricing-switch-group-v3 {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 15px;\r\n}\r\n\r\n.currency-select {\r\n  -webkit-appearance: none;\r\n  -moz-appearance: none;\r\n  appearance: none;\r\n  padding: 10px 42px 10px 16px;\r\n  font-size: 15px;\r\n  font-weight: 600;\r\n  background: #ffffff;\r\n  border: 2px solid #e2e8f0;\r\n  border-radius: 14px;\r\n  cursor: pointer;\r\n  transition: all 0.25s ease;\r\n  box-shadow: 0 3px 10px rgba(15, 23, 42, 0.08);\r\n  color: #0f172a;\r\n  background-image: url(\"data:image/svg+xml;utf8,<svg fill='%2367768a' width='16' height='16' viewBox='0 0 24 24'><path d='M7 10l5 5 5-5'/></svg>\");\r\n  background-position: right 12px center;\r\n  background-repeat: no-repeat;\r\n}\r\n\r\n.currency-select:hover {\r\n  border-color: #cbd5e1;\r\n  background-color: #f8fafc;\r\n}\r\n\r\n.currency-select:focus {\r\n  border-color: #6366f1;\r\n  box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.2);\r\n  outline: none;\r\n}\r\n\r\n.currency-select option {\r\n  font-size: 15px;\r\n  font-weight: 500;\r\n  padding: 8px;\r\n}\r\n\r\n.billing-toggle {\r\n  position: relative;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  background: #f1f5f9;\r\n  border-radius: 999px;\r\n  padding: 6px;\r\n  gap: 6px;\r\n  border: 1px solid #e2e8f0;\r\n  box-shadow: inset 0 1px 3px rgba(0, 0, 0, 0.06);\r\n}\r\n\r\n.toggle-btn {\r\n  position: relative;\r\n  z-index: 2;\r\n  border: none;\r\n  background: none;\r\n  padding: 10px 26px;\r\n  font-size: 15px;\r\n  font-weight: 600;\r\n  color: #475569;\r\n  cursor: pointer;\r\n  border-radius: 999px;\r\n  white-space: nowrap;\r\n  transition: color 0.25s ease;\r\n}\r\n\r\n.toggle-btn.active {\r\n  color: #fff;\r\n  font-weight: 700;\r\n}\r\n\r\n.toggle-highlight {\r\n  position: absolute;\r\n  top: 6px;\r\n  bottom: 6px;\r\n  background: linear-gradient(135deg, #6366f1, #7c3aed);\r\n  border-radius: 999px;\r\n  box-shadow: 0px 6px 22px rgba(99, 102, 241, 0.35);\r\n  z-index: 1;\r\n  transition: all 0.28s ease;\r\n}\r\n\r\n.toggle-left {\r\n  transform: translateX(0%);\r\n  width: calc(50% - 6px);\r\n}\r\n\r\n.toggle-right {\r\n  transform: translateX(100%);\r\n  width: calc(50% - 6px);\r\n}\r\n\r\n.baseservices-section {\r\n  padding: 30px 15px;\r\n  max-width: 1200px;\r\n  margin: auto;\r\n}\r\n\r\n.baseservices-title {\r\n  font-size: 28px;\r\n  font-weight: 700;\r\n  margin-bottom: 6px;\r\n}\r\n\r\n.baseservices-subtitle {\r\n  color: #777;\r\n  margin-bottom: 32px;\r\n}\r\n\r\n.baseservices-grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));\r\n  gap: 24px;\r\n}\r\n\r\n.baseservice-card {\r\n  background: #fff;\r\n  border-radius: 18px;\r\n  padding: 24px;\r\n  box-shadow: 0 6px 24px rgba(0, 0, 0, 0.06);\r\n  display: flex;\r\n  flex-direction: column;\r\n  transition: 0.3s ease;\r\n}\r\n\r\n.baseservice-card:hover {\r\n  transform: translateY(-6px);\r\n  box-shadow: 0 12px 36px rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n.baseservice-card h3 {\r\n  font-size: 18px;\r\n  font-weight: 700;\r\n  margin: 12px 0 10px;\r\n}\r\n\r\n.baseservice-card p {\r\n  color: #666;\r\n  font-size: 14px;\r\n  line-height: 1.6;\r\n  flex-grow: 1;\r\n}\r\n\r\n.baseservice-btn-wrap {\r\n  margin-top: 18px;\r\n}\r\n\r\n.baseservice-icon {\r\n  width: 44px;\r\n  height: 44px;\r\n  border-radius: 12px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  font-size: 20px;\r\n  color: #fff;\r\n}\r\n\r\n.baseservice-btn {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n  padding: 10px 16px;\r\n  border-radius: 10px;\r\n  font-size: 14px;\r\n  font-weight: 600;\r\n  color: #fff;\r\n  text-decoration: none;\r\n  transition: 0.3s ease;\r\n}\r\n\r\n.baseservice-btn .arrow {\r\n  display: inline-block;\r\n  transition: transform 0.3s ease;\r\n}\r\n\r\n.baseservice-btn:hover .arrow {\r\n  transform: translateX(6px);\r\n}\r\n\r\n.baseservice-btn:hover {\r\n  color: #fff;\r\n}\r\n\r\n.flicknexs {\r\n  background: #2563eb;\r\n  color: #fff;\r\n}\r\n\r\n.flicknexs:hover {\r\n  background: #2563eb;\r\n  color: #fff;\r\n}\r\n\r\n.purple {\r\n  background: #7c3aed;\r\n}\r\n\r\n.primary {\r\n  background: #2563eb;\r\n}\r\n\r\n.warning {\r\n  background: #f97316;\r\n}\r\n\r\n.dark {\r\n  background: #111827;\r\n}\r\n\r\n.success {\r\n  background: #16a34a;\r\n}\r\n\r\n.info {\r\n  background: #6366f1;\r\n}\r\n\r\n.danger {\r\n  background: #db2777;\r\n}\r\n\r\n.adminforgot .model-x-button button {\r\n  font-size: 13px;\r\n  right: 5px;\r\n  top: 5px;\r\n}\r\n\r\n\r\n@media (max-width: 900px) {\r\n  .sub-page {\r\n    grid-template-columns: 1fr;\r\n  }\r\n}\r\n\r\n@keyframes shimmer {\r\n  100% {\r\n    transform: translateX(100%);\r\n  }\r\n}\r\n\r\n/* ==========================================================================\r\n   PREMIUM FILE UPLOADER COMPONENT STYLES\r\n   ========================================================================== */\r\n\r\n.premium-uploader-container {\r\n  width: 100%;\r\n  max-width: 620px;\r\n  margin: 24px auto;\r\n  font-family: \"Poppins\", \"Inter\", sans-serif;\r\n}\r\n\r\n/* Premium Dropzone Area */\r\n.premium-dropzone {\r\n  border: 2px dashed rgba(99, 102, 241, 0.4);\r\n  background: rgba(99, 102, 241, 0.03);\r\n  padding: 42px 28px;\r\n  text-align: center;\r\n  cursor: pointer;\r\n  border-radius: 20px;\r\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\r\n  position: relative;\r\n  overflow: hidden;\r\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);\r\n}\r\n\r\n.premium-dropzone:hover {\r\n  border-color: #6366f1;\r\n  background: rgba(99, 102, 241, 0.06);\r\n  transform: translateY(-2px);\r\n  box-shadow: 0 10px 30px rgba(99, 102, 241, 0.1);\r\n}\r\n\r\n.premium-dropzone.is-dragging {\r\n  border-color: #10b981;\r\n  background: rgba(16, 185, 129, 0.08);\r\n  transform: scale(1.02);\r\n  box-shadow: 0 12px 35px rgba(16, 185, 129, 0.15);\r\n}\r\n\r\n/* Icon wrapper with glow & pulse animation */\r\n.premium-dropzone-icon-wrapper {\r\n  width: 68px;\r\n  height: 68px;\r\n  margin: 0 auto 16px;\r\n  background: linear-gradient(135deg, rgba(99, 102, 241, 0.12) 0%, rgba(168, 85, 247, 0.12) 100%);\r\n  border-radius: 50%;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  transition: all 0.3s ease;\r\n}\r\n\r\n.premium-dropzone:hover .premium-dropzone-icon-wrapper {\r\n  transform: translateY(-4px) scale(1.08);\r\n  background: linear-gradient(135deg, rgba(99, 102, 241, 0.2) 0%, rgba(168, 85, 247, 0.2) 100%);\r\n}\r\n\r\n.premium-dropzone.is-dragging .premium-dropzone-icon-wrapper {\r\n  background: linear-gradient(135deg, rgba(16, 185, 129, 0.18) 0%, rgba(52, 211, 153, 0.18) 100%);\r\n  transform: scale(1.1);\r\n}\r\n\r\n.premium-dropzone-icon {\r\n  font-size: 30px;\r\n  color: #6366f1;\r\n  transition: all 0.3s ease;\r\n}\r\n\r\n.premium-dropzone:hover .premium-dropzone-icon {\r\n  color: #a855f7;\r\n}\r\n\r\n.premium-dropzone.is-dragging .premium-dropzone-icon {\r\n  color: #10b981;\r\n}\r\n\r\n/* Text structure */\r\n.premium-dropzone-title {\r\n  margin: 0 0 6px;\r\n  font-size: 1.15rem;\r\n  font-weight: 600;\r\n  color: inherit;\r\n}\r\n\r\n.premium-dropzone-subtitle {\r\n  margin: 0 0 20px;\r\n  font-size: 0.9rem;\r\n  color: #6b7280;\r\n}\r\n\r\n/* Tag specs styling */\r\n.premium-dropzone-specs {\r\n  display: flex;\r\n  justify-content: center;\r\n  gap: 10px;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.spec-tag {\r\n  background: rgba(255, 255, 255, 0.7);\r\n  border: 1px solid rgba(0, 0, 0, 0.05);\r\n  padding: 5px 12px;\r\n  border-radius: 50px;\r\n  font-size: 0.75rem;\r\n  font-weight: 500;\r\n  color: #4b5563;\r\n  transition: all 0.2s ease;\r\n}\r\n\r\n/* Dark mode compatibility */\r\n.theme-bg-color-secondary .spec-tag {\r\n  background: rgba(255, 255, 255, 0.05);\r\n  border-color: rgba(255, 255, 255, 0.08);\r\n  color: #d1d5db;\r\n}\r\n\r\n.premium-dropzone:hover .spec-tag {\r\n  background: rgba(99, 102, 241, 0.08);\r\n  border-color: rgba(99, 102, 241, 0.15);\r\n  color: #6366f1;\r\n}\r\n\r\n/* File list section styling */\r\n.premium-file-list {\r\n  margin-top: 28px;\r\n  animation: premiumFadeIn 0.4s ease-out;\r\n}\r\n\r\n.premium-file-list-header {\r\n  margin-bottom: 12px;\r\n}\r\n\r\n.premium-file-list-header h4 {\r\n  font-size: 0.95rem;\r\n  font-weight: 600;\r\n  margin: 0;\r\n  color: inherit;\r\n}\r\n\r\n.premium-file-list-items {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 12px;\r\n}\r\n\r\n/* High fidelity card for items in upload list */\r\n.premium-file-card {\r\n  background: rgba(255, 255, 255, 0.4);\r\n  border: 1px solid rgba(99, 102, 241, 0.1);\r\n  border-radius: 16px;\r\n  padding: 16px;\r\n  transition: all 0.3s ease;\r\n  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.02);\r\n}\r\n\r\n.theme-bg-color-secondary .premium-file-card {\r\n  background: rgba(255, 255, 255, 0.02);\r\n  border-color: rgba(255, 255, 255, 0.05);\r\n}\r\n\r\n.premium-file-card:hover {\r\n  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.06);\r\n  transform: translateY(-1px);\r\n}\r\n\r\n/* Card Header - File info */\r\n.premium-file-info {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 12px;\r\n  margin-bottom: 12px;\r\n}\r\n\r\n.file-icon-wrapper {\r\n  width: 40px;\r\n  height: 40px;\r\n  background: rgba(99, 102, 241, 0.08);\r\n  border-radius: 10px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.file-icon {\r\n  font-size: 18px;\r\n  color: #6366f1;\r\n}\r\n\r\n.file-metadata {\r\n  flex-grow: 1;\r\n  display: flex;\r\n  flex-direction: column;\r\n  min-width: 0;\r\n}\r\n\r\n.file-name {\r\n  font-size: 0.9rem;\r\n  font-weight: 600;\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  color: inherit;\r\n}\r\n\r\n.file-size {\r\n  font-size: 0.75rem;\r\n  color: #6b7280;\r\n  margin-top: 1px;\r\n}\r\n\r\n/* Button styling inside queue cards */\r\n.file-actions {\r\n  display: flex;\r\n  gap: 6px;\r\n  align-items: center;\r\n}\r\n\r\n.btn-action {\r\n  width: 30px;\r\n  height: 30px;\r\n  border-radius: 50%;\r\n  border: none;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  cursor: pointer;\r\n  transition: all 0.2s ease;\r\n  font-size: 13px;\r\n  background: rgba(0, 0, 0, 0.04);\r\n  color: #4b5563;\r\n}\r\n\r\n.theme-bg-color-secondary .btn-action {\r\n  background: rgba(255, 255, 255, 0.06);\r\n  color: #d1d5db;\r\n}\r\n\r\n.btn-action:hover {\r\n  transform: scale(1.1);\r\n}\r\n\r\n.btn-action.pause:hover {\r\n  background: rgba(239, 68, 68, 0.12);\r\n  color: #ef4444;\r\n}\r\n\r\n.btn-action.resume:hover {\r\n  background: rgba(16, 185, 129, 0.12);\r\n  color: #10b981;\r\n}\r\n\r\n.btn-action.remove:hover {\r\n  background: rgba(239, 68, 68, 0.12);\r\n  color: #ef4444;\r\n}\r\n\r\n/* Progress bar inside cards */\r\n.premium-progress-container {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 6px;\r\n}\r\n\r\n.premium-progress-bar-wrapper {\r\n  width: 100%;\r\n  height: 5px;\r\n  background: rgba(0, 0, 0, 0.05);\r\n  border-radius: 10px;\r\n  overflow: hidden;\r\n}\r\n\r\n.theme-bg-color-secondary .premium-progress-bar-wrapper {\r\n  background: rgba(255, 255, 255, 0.08);\r\n}\r\n\r\n.premium-progress-bar {\r\n  height: 100%;\r\n  border-radius: 10px;\r\n  transition: width 0.3s cubic-bezier(0.4, 0, 0.2, 1);\r\n  background: linear-gradient(90deg, #6366f1 0%, #a855f7 100%);\r\n}\r\n\r\n.premium-progress-bar.done {\r\n  background: #10b981;\r\n}\r\n\r\n.premium-progress-bar.error {\r\n  background: #ef4444;\r\n}\r\n\r\n.premium-progress-bar.cancelled {\r\n  background: #f59e0b;\r\n}\r\n\r\n/* Details row under progress bar */\r\n.premium-progress-details {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  font-size: 0.78rem;\r\n  font-weight: 500;\r\n}\r\n\r\n.progress-status-text {\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n\r\n.progress-speed {\r\n  color: #4b5563;\r\n}\r\n\r\n.theme-bg-color-secondary .progress-speed {\r\n  color: #9ca3af;\r\n}\r\n\r\n.text-success-g {\r\n  color: #10b981 !important;\r\n}\r\n\r\n.text-warning-g {\r\n  color: #f59e0b !important;\r\n}\r\n\r\n.text-error-g {\r\n  color: #ef4444 !important;\r\n}\r\n\r\n.me-1 {\r\n  margin-right: 4px;\r\n}\r\n\r\n/* Spinner and micro animations */\r\n.spin {\r\n  animation: premiumSpin 1s linear infinite;\r\n}\r\n\r\n.animate-pulse {\r\n  animation: premiumPulse 1.5s ease-in-out infinite;\r\n}\r\n\r\n@keyframes premiumSpin {\r\n  0% { transform: rotate(0deg); }\r\n  100% { transform: rotate(360deg); }\r\n}\r\n\r\n@keyframes premiumFadeIn {\r\n  from { opacity: 0; transform: translateY(8px); }\r\n  to { opacity: 1; transform: translateY(0); }\r\n}\r\n\r\n@keyframes premiumPulse {\r\n  0%, 100% { opacity: 1; }\r\n  50% { opacity: .6; }\r\n}\r"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
